export const Loginillu = ({ primaryColor = '#ffd800' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80%"
      height="320"
      viewBox="0 0 962.705 345.428"
    >
      <g
        id="Group_41113"
        data-name="Group 41113"
        transform="translate(-19.166 -726)"
      >
        <g
          id="_13746503_5340735"
          data-name="13746503_5340735"
          transform="translate(19.166 726)"
        >
          <rect
            id="Rectangle_19411"
            data-name="Rectangle 19411"
            width="31.026"
            height="0.234"
            transform="translate(390.407 321.804)"
            fill="#ebebeb"
          />
          <rect
            id="Rectangle_19412"
            data-name="Rectangle 19412"
            width="8.143"
            height="0.234"
            transform="translate(302.118 324.346)"
            fill="#ebebeb"
          />
          <rect
            id="Rectangle_19413"
            data-name="Rectangle 19413"
            width="17.978"
            height="0.234"
            transform="translate(371.492 313.105)"
            fill="#ebebeb"
          />
          <rect
            id="Rectangle_19414"
            data-name="Rectangle 19414"
            width="40.46"
            height="0.234"
            transform="translate(49.139 314.679)"
            fill="#ebebeb"
          />
          <rect
            id="Rectangle_19415"
            data-name="Rectangle 19415"
            width="5.932"
            height="0.234"
            transform="translate(97.94 314.679)"
            fill="#ebebeb"
          />
          <rect
            id="Rectangle_19416"
            data-name="Rectangle 19416"
            width="87.749"
            height="0.234"
            transform="translate(123.152 318.634)"
            fill="#ebebeb"
          />
          <g
            id="Group_40562"
            data-name="Group 40562"
            transform="translate(37.088)"
          >
            <path
              id="Path_62762"
              data-name="Path 62762"
              d="M225.821,319.9H44.941a5.353,5.353,0,0,1-5.347-5.347V60.3a5.353,5.353,0,0,1,5.347-5.347h180.88a5.353,5.353,0,0,1,5.346,5.347V314.555A5.353,5.353,0,0,1,225.821,319.9ZM44.941,55.187A5.118,5.118,0,0,0,39.828,60.3V314.556a5.118,5.118,0,0,0,5.113,5.113h180.88a5.118,5.118,0,0,0,5.112-5.113V60.3a5.118,5.118,0,0,0-5.112-5.113H44.941Z"
              transform="translate(-39.594 -54.952)"
              fill="#ebebeb"
            />
            <path
              id="Path_62763"
              data-name="Path 62763"
              d="M442.118,319.9H261.238a5.353,5.353,0,0,1-5.346-5.347V60.3a5.353,5.353,0,0,1,5.346-5.347h180.88a5.353,5.353,0,0,1,5.347,5.347V314.555A5.353,5.353,0,0,1,442.118,319.9ZM261.238,55.187a5.118,5.118,0,0,0-5.112,5.113V314.556a5.118,5.118,0,0,0,5.112,5.113h180.88a5.118,5.118,0,0,0,5.113-5.113V60.3a5.119,5.119,0,0,0-5.113-5.113H261.238Z"
              transform="translate(-53.28 -54.952)"
              fill="#ebebeb"
            />
          </g>
          <rect
            id="Rectangle_19417"
            data-name="Rectangle 19417"
            width="468.362"
            height="0.234"
            transform="translate(0 306.726)"
            fill="#ebebeb"
          />
          <g
            id="Group_40567"
            data-name="Group 40567"
            transform="translate(894.073 210.219)"
          >
            <g
              id="Group_40564"
              data-name="Group 40564"
              transform="translate(22.463)"
            >
              <path
                id="Path_62764"
                data-name="Path 62764"
                d="M397.787,252.725l-13.168-4.07a.856.856,0,0,1,.3-1.671c4.92.259,8.949.473,15.175.8-3.584-6.233-5.7-10.123-8.114-15a.856.856,0,0,1,1.406-.949c3.24,3.643,5.95,6.6,10.294,11.266,1.037-6.034,2.237-11.586,3.741-17.169a.856.856,0,0,1,1.679.293,120.278,120.278,0,0,0-.438,13.513l.414.146q5.471-6.234,11.463-11.982a.856.856,0,0,1,1.256,1.156,157.139,157.139,0,0,0-10.714,15.379q7.812-2.947,15.7-5.716a.856.856,0,0,1,.706,1.552c-5.454,3.09-10.846,6.253-16.232,9.528l13.876,4.419a.855.855,0,0,1-.31,1.669l-14.26-.86c2.818,3.3,4.777,5.564,7.056,8.125a.855.855,0,0,1-1.112,1.281c-2.866-1.9-5.388-3.59-9.059-6.054.372,2.933.7,5.2,1.084,7.428a.855.855,0,0,1-1.64.457c-.953-2.438-1.825-4.865-2.932-8.082-4.144,19.83-3.07,39.051.937,58.763l-4.966-.9a154.26,154.26,0,0,1,2.329-58.173c-2.489,2.568-4.318,4.507-6.063,6.458a.855.855,0,0,1-1.37-1.012c1.171-1.942,2.444-3.919,4.144-6.473-4.434.972-7.471,1.644-10.818,2.4a.855.855,0,0,1-.57-1.6C390.706,256.1,393.57,254.72,397.787,252.725Z"
                transform="translate(-384.016 -225.299)"
                fill="#ebebeb"
              />
            </g>
            <g
              id="Group_40565"
              data-name="Group 40565"
              transform="translate(0 11.996)"
            >
              <path
                id="Path_62765"
                data-name="Path 62765"
                d="M387.173,261.5l10.111-5.362a1.146,1.146,0,0,0-.812-2.125c-3.841.942-7.414,1.82-12.487,3.065,2.035-5.863,3.321-9.806,4.575-14.148a1.146,1.146,0,0,0-2.083-.909c-2.053,3.4-4.008,6.552-6.889,11.122-1.746-4.667-3.539-9-5.5-13.259a1.143,1.143,0,0,0-2.142.771c.862,3.375,1.575,6.775,2.124,10.114l-.378.221q-4.9-3.828-10.048-7.332a1.145,1.145,0,0,0-1.423,1.786q5.414,4.951,10.35,10.393-6.638-1.159-13.305-2.2a1.145,1.145,0,0,0-.543,2.214c4.9,1.7,9.785,3.453,14.674,5.286l-10.757,5.822a1.146,1.146,0,0,0,.826,2.119l11.589-2.934c-1.679,2.94-2.963,5.163-4.282,7.394a1.146,1.146,0,0,0,1.789,1.4c1.866-1.829,3.723-3.658,6.178-6.083.108,1.745.188,3.258.244,4.671a1.146,1.146,0,0,0,2.275.141c.284-1.7.561-3.512.871-5.657,7.772,18.708,10.3,37.792,10.047,57.9l4.711-1.808A154.265,154.265,0,0,0,383.738,267.4c1.786,1.256,3.286,2.329,4.657,3.336a1.145,1.145,0,0,0,1.516-1.7c-.931-.989-1.953-2.047-3.133-3.252,3.456.1,6.083.174,8.654.257a1.146,1.146,0,0,0,.34-2.25C393.235,263.091,390.627,262.4,387.173,261.5Z"
                transform="translate(-357.944 -239.222)"
                fill="#f0f0f0"
              />
            </g>
            <g
              id="Group_40566"
              data-name="Group 40566"
              transform="translate(39.112 28.685)"
            >
              <path
                id="Path_62766"
                data-name="Path 62766"
                d="M411.317,275.051l-7.542-4a.811.811,0,0,1,.573-1.5c2.872.7,5.511,1.352,9.293,2.281-1.511-4.353-2.455-7.254-3.385-10.488a.811.811,0,0,1,1.474-.644c1.532,2.541,2.972,4.863,5.116,8.264,1.3-3.488,2.645-6.72,4.12-9.9a.81.81,0,0,1,1.517.547c-.661,2.56-1.205,5.141-1.621,7.674l.242.141q3.723-2.909,7.638-5.562a.812.812,0,0,1,1,1.275q-4.072,3.7-7.776,7.788,4.969-.867,9.961-1.641a.811.811,0,0,1,.387,1.567c-3.661,1.264-7.3,2.573-10.951,3.941l8.013,4.336a.811.811,0,0,1-.585,1.5l-8.635-2.186c1.263,2.212,2.219,3.867,3.214,5.546a.811.811,0,0,1-1.265.993c-1.405-1.377-2.788-2.738-4.635-4.563-.084,1.369-.146,2.542-.186,3.639a.811.811,0,0,1-1.609.105c-.221-1.307-.434-2.7-.675-4.36-5.666,13.638-7.512,27.55-7.324,42.211l-3.434-1.318a112.464,112.464,0,0,1,9.582-41.345c-1.395.981-2.551,1.809-3.607,2.588a.811.811,0,0,1-1.073-1.206c.728-.776,1.528-1.607,2.466-2.564-2.61.073-4.572.131-6.512.194a.811.811,0,0,1-.24-1.593C406.764,276.244,408.71,275.729,411.317,275.051Z"
                transform="translate(-403.34 -258.593)"
                fill="#f5f5f5"
              />
            </g>
            <path
              id="Path_62767"
              data-name="Path 62767"
              d="M386.927,374.364h25.694a3.4,3.4,0,0,0,3.393-3.191l2.723-44.314c.121-1.956-38.047-1.956-37.926,0l2.723,44.314A3.4,3.4,0,0,0,386.927,374.364Z"
              transform="translate(-361.109 -239.155)"
              fill="#e0e0e0"
            />
            <path
              id="Path_62768"
              data-name="Path 62768"
              d="M384.61,262.224a2.6,2.6,0,0,1-.924-2.3l.578-4.911-1.318,2.284a2.6,2.6,0,0,1-3.813.775l-2.577-1.945,2.355,3.8a2.6,2.6,0,0,1-.518,3.339l-3.045,2.61,2.985-.681a2.6,2.6,0,0,1,3.045,1.723l1.028,3.137.657-3.337a2.6,2.6,0,0,1,3.281-1.989l2.006.59Z"
              transform="translate(-360.353 -229.412)"
              fill="#e6e6e6"
            />
            <path
              id="Path_62769"
              data-name="Path 62769"
              d="M405.552,252.715a1.9,1.9,0,0,0,.675-1.683l-.422-3.588.962,1.668a1.9,1.9,0,0,0,2.785.566l1.883-1.421-1.721,2.777a1.9,1.9,0,0,0,.378,2.439l2.225,1.907-2.181-.5a1.9,1.9,0,0,0-2.225,1.259l-.75,2.291-.48-2.437a1.9,1.9,0,0,0-2.4-1.453l-1.465.431Z"
              transform="translate(-364.156 -228.364)"
              fill="#f5f5f5"
            />
            <path
              id="Path_62770"
              data-name="Path 62770"
              d="M417.465,276.818a1.36,1.36,0,0,0,.484-1.208l-.3-2.574.691,1.2a1.361,1.361,0,0,0,2,.406l1.351-1.019-1.235,1.993a1.361,1.361,0,0,0,.271,1.75l1.6,1.368-1.565-.357a1.362,1.362,0,0,0-1.6.9l-.538,1.644-.345-1.749a1.361,1.361,0,0,0-1.72-1.042l-1.051.309Z"
              transform="translate(-365.912 -231.907)"
              fill="#e6e6e6"
            />
          </g>
          <g id="Character_3" transform="translate(635.344 36.752)">
            <g id="Group_40653" data-name="Group 40653">
              <path
                id="Path_62852"
                data-name="Path 62852"
                d="M303.133,427.57c0,36.018,60.6,44.825,135.363,44.825s104.775-8.807,104.775-44.825-21.106-79.807-95.863-79.807S303.133,391.552,303.133,427.57Z"
                transform="translate(-293.014 -165.51)"
                fill={primaryColor}
              />
              <path
                id="Path_62854"
                data-name="Path 62854"
                d="M298.542,412.166c-2.75,49.531,10.944,76.272,42.168,78.007s58.767-37.012,61.517-86.543-28.7-87.468-59.925-89.2S301.292,362.635,298.542,412.166Z"
                transform="translate(-298.198 -200.577)"
                fill={primaryColor}
              />
              <path
                id="Path_62857"
                data-name="Path 62857"
                d="M345.324,368.311s-30.067-5.282-31.724,7.3S309.651,369.578,345.324,368.311Z"
                transform="translate(-282.832 -145.079)"
                opacity="0.1"
              />
              <path
                id="Path_62858"
                data-name="Path 62858"
                d="M312.14,417.142c-8.45-9.894-13.025-25.257-13.864-45.82,3.872,39.17,26.6,64.543,117.4,68.636,90.983,4.1,111-23.069,120.737-19.823,4.091,1.364,4.107,5.11,2.756,9-13.868,14.34-44.124,18.512-95.57,18.512C379.968,447.646,326.621,441.252,312.14,417.142Z"
                transform="translate(-298.116 -140.759)"
                opacity="0.1"
              />
              <g
                id="Group_40652"
                data-name="Group 40652"
                transform="translate(45.211)"
              >
                <path
                  id="Path_62859"
                  data-name="Path 62859"
                  d="M390.1,311.937s-4.247.675-6.748,3.219-9.882,2.282-9.882,2.282l-.734,8.34,16.825-.974Z"
                  transform="translate(-265.101 -203.146)"
                  fill="#b25b52"
                />
                <path
                  id="Path_62860"
                  data-name="Path 62860"
                  d="M349.556,287.625c2.2-.125,10.6,4.259,15.666,26.436s3.941,29.616,43.271,27.094l-1.28,11.044s-34.08,3.656-44.247-4.511C352.835,339.551,341.438,288.087,349.556,287.625Z"
                  transform="translate(-292.355 -228.69)"
                  fill="#263238"
                />
                <path
                  id="Path_62861"
                  data-name="Path 62861"
                  d="M356.711,300.927l1.917,3.4s-2.11,20.889,1.913,30.533a12.941,12.941,0,0,1-1.735-1.142c-2.727-2.19-5.545-7.536-8.05-14.167Z"
                  transform="translate(-288.194 -214.713)"
                  opacity="0.6"
                />
                <g
                  id="Group_40643"
                  data-name="Group 40643"
                  transform="translate(7.01)"
                >
                  <path
                    id="Path_62862"
                    data-name="Path 62862"
                    d="M329.029,270.657s-.287,6.467-3.293,7.794,2.208,8.733.755,13.265-4.817,8.606-1.218,14.676c0,0-.777-5.063,1.778-8.075,0,0-1.07,8.491,1.679,8.676s3.293-2.3,7.8-1.241.531-6.935.531-6.935,1.817,1.2,3.033,5.444,13.156-.652,18.014,1.093,6.207-7.232,6.207-7.232,2.163,5.331.408,7.154c0,0,3.826-1.1,4.251-6.17,0,0,1.122,1.542.552,4.768,0,0,3.683-.269,2.762-7.4s-6.486-9.189-7.936-14.852-19.292-16.63-19.292-16.63Z"
                    transform="translate(-323.665 -252.47)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62863"
                    data-name="Path 62863"
                    d="M330.961,278.384l15.207,9.9c-.055,10.673,7.657,10.111,7.657,10.111s.123,3.724-9.174,5.1-12.5,1-12.5,1C336.787,298.947,333.27,285.637,330.961,278.384Z"
                    transform="translate(-316.001 -238.396)"
                    fill="#ebb376"
                  />
                  <path
                    id="Path_62864"
                    data-name="Path 62864"
                    d="M346.815,293.523a13.716,13.716,0,0,1-1.052-5.791L332.2,278.905l-.851,1.513S336.489,294.12,346.815,293.523Z"
                    transform="translate(-315.596 -237.848)"
                    opacity="0.1"
                  />
                  <path
                    id="Path_62865"
                    data-name="Path 62865"
                    d="M328.9,280.357c1.548,12.4,1.93,17.688,8.614,23.682,10.058,9.022,24.951,4.419,27.151-8.2,1.977-11.354-.876-29.719-13.363-33.914a17.048,17.048,0,0,0-22.4,18.428Z"
                    transform="translate(-318.334 -256.649)"
                    fill="#ebb376"
                  />
                  <path
                    id="Path_62866"
                    data-name="Path 62866"
                    d="M342.192,274.006a27.009,27.009,0,0,0,4.015,6.25,4.344,4.344,0,0,1-3.564.915Z"
                    transform="translate(-304.202 -242.995)"
                    fill="#ebb376"
                  />
                  <path
                    id="Path_62867"
                    data-name="Path 62867"
                    d="M337.079,272.441a.549.549,0,0,1-.236-.1.5.5,0,0,1-.08-.7l.006-.008a5.793,5.793,0,0,1,4.827-2.288.509.509,0,0,1,.441.545.5.5,0,0,1-.531.443,4.852,4.852,0,0,0-3.976,1.93A.5.5,0,0,1,337.079,272.441Z"
                    transform="translate(-310.018 -247.891)"
                    fill="#2e353a"
                  />
                  <path
                    id="Path_62868"
                    data-name="Path 62868"
                    d="M348.5,270.987a.548.548,0,0,1-.236-.1,4.844,4.844,0,0,0-4.312-.863.5.5,0,0,1-.64-.287s0,0,0-.006a.51.51,0,0,1,.308-.64,5.847,5.847,0,0,1,5.251,1,.5.5,0,0,1-.369.9Z"
                    transform="translate(-303.051 -248.41)"
                    fill="#2e353a"
                  />
                  <g
                    id="Group_40642"
                    data-name="Group 40642"
                    transform="translate(30.722 26.383)"
                  >
                    <path
                      id="Path_62869"
                      data-name="Path 62869"
                      d="M338.652,274.387c.061,1.007.65,1.794,1.321,1.757s1.144-.89,1.072-1.911-.65-1.794-1.308-1.755S338.593,273.366,338.652,274.387Z"
                      transform="translate(-338.648 -270.985)"
                      fill="#2e353a"
                    />
                    <path
                      id="Path_62870"
                      data-name="Path 62870"
                      d="M344.244,274.038c.062,1.007.65,1.794,1.308,1.755s1.144-.89,1.087-1.909-.65-1.794-1.308-1.755S344.17,273.017,344.244,274.038Z"
                      transform="translate(-332.776 -271.352)"
                      fill="#2e353a"
                    />
                    <path
                      id="Path_62871"
                      data-name="Path 62871"
                      d="M344.629,272.6l2.389-.849S345.882,273.722,344.629,272.6Z"
                      transform="translate(-332.364 -271.749)"
                      fill="#2e353a"
                    />
                    <path
                      id="Path_62872"
                      data-name="Path 62872"
                      d="M339.04,272.947l2.389-.849S340.293,274.071,339.04,272.947Z"
                      transform="translate(-338.235 -271.382)"
                      fill="#2e353a"
                    />
                  </g>
                  <path
                    id="Path_62873"
                    data-name="Path 62873"
                    d="M339.651,279.052a7.229,7.229,0,0,1-.724-.984.239.239,0,0,1,.062-.332.01.01,0,0,1,.008,0,.253.253,0,0,1,.336.09,6.582,6.582,0,0,0,5.014,3.16.244.244,0,1,1-.008.488A6.781,6.781,0,0,1,339.651,279.052Z"
                    transform="translate(-307.675 -239.113)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62874"
                    data-name="Path 62874"
                    d="M354.168,263.873s6.66,7.394-.6,10.353-13.8,7.318-14.862,13.441a7.489,7.489,0,0,1-6.99,6.312s-9.6-12.166-3.4-24.959S351.633,259.405,354.168,263.873Z"
                    transform="translate(-320.974 -257.758)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62875"
                    data-name="Path 62875"
                    d="M330.464,266.922s8.012-12.4,21.449-6.4,14.026,16.191,10.646,15.19-8.748-2.024-12.594-8.973S330.464,266.922,330.464,266.922Z"
                    transform="translate(-316.523 -258.883)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62876"
                    data-name="Path 62876"
                    d="M331.42,274.2s6.619-.377,3.469,8.338C334.889,282.535,334.4,277.021,331.42,274.2Z"
                    transform="translate(-315.518 -242.796)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62877"
                    data-name="Path 62877"
                    d="M327.854,278.288a9.113,9.113,0,0,0,4.733,5.124c2.92,1.316,4.86-1.173,4.454-4.183-.363-2.7-2.323-6.65-5.452-6.705a4.127,4.127,0,0,0-4.072,4.181A4.085,4.085,0,0,0,327.854,278.288Z"
                    transform="translate(-319.621 -244.552)"
                    fill="#ebb376"
                  />
                </g>
                <g
                  id="Group_40647"
                  data-name="Group 40647"
                  transform="translate(73.814 86.369)"
                >
                  <g id="Group_40644" data-name="Group 40644">
                    <path
                      id="Path_62878"
                      data-name="Path 62878"
                      d="M392.613,352.019l-35.421-4.907a1.1,1.1,0,0,1-.826-1.589l21.99-42.826a3.12,3.12,0,0,1,3.205-1.665l35.421,4.907a1.1,1.1,0,0,1,.826,1.589l-21.99,42.826A3.12,3.12,0,0,1,392.613,352.019Z"
                      transform="translate(-356.244 -301.003)"
                      fill="#263238"
                    />
                    <path
                      id="Path_62879"
                      data-name="Path 62879"
                      d="M392.613,352.019l-35.421-4.907a1.1,1.1,0,0,1-.826-1.589l21.99-42.826a3.12,3.12,0,0,1,3.205-1.665l35.421,4.907a1.1,1.1,0,0,1,.826,1.589l-21.99,42.826A3.12,3.12,0,0,1,392.613,352.019Z"
                      transform="translate(-356.244 -301.003)"
                      fill="#fff"
                      opacity="0.5"
                    />
                  </g>
                  <g
                    id="Group_40646"
                    data-name="Group 40646"
                    transform="translate(1.386 0.191)"
                  >
                    <path
                      id="Path_62880"
                      data-name="Path 62880"
                      d="M393.289,352.114l-35.421-4.907a1.1,1.1,0,0,1-.826-1.589l21.99-42.826a3.126,3.126,0,0,1,3.205-1.667l35.421,4.907a1.1,1.1,0,0,1,.826,1.589l-21.99,42.826A3.118,3.118,0,0,1,393.289,352.114Z"
                      transform="translate(-356.92 -301.096)"
                      fill="#263238"
                    />
                    <path
                      id="Path_62881"
                      data-name="Path 62881"
                      d="M393.289,352.114l-35.421-4.907a1.1,1.1,0,0,1-.826-1.589l21.99-42.826a3.126,3.126,0,0,1,3.205-1.667l35.421,4.907a1.1,1.1,0,0,1,.826,1.589l-21.99,42.826A3.118,3.118,0,0,1,393.289,352.114Z"
                      transform="translate(-356.92 -301.096)"
                      fill="#fff"
                      opacity="0.7"
                    />
                    <g
                      id="Group_40645"
                      data-name="Group 40645"
                      transform="translate(51.696 6.461)"
                    >
                      <path
                        id="Path_62882"
                        data-name="Path 62882"
                        d="M386.325,310.131l-4.085-.566a.127.127,0,0,1-.1-.182l2.536-4.94a.361.361,0,0,1,.369-.193l4.085.566a.126.126,0,0,1,.094.182l-2.537,4.94A.354.354,0,0,1,386.325,310.131Z"
                        transform="translate(-382.13 -304.246)"
                        fill="#263238"
                        opacity="0.7"
                      />
                      <path
                        id="Path_62883"
                        data-name="Path 62883"
                        d="M386.325,310.131l-4.085-.566a.127.127,0,0,1-.1-.182l2.536-4.94a.361.361,0,0,1,.369-.193l4.085.566a.126.126,0,0,1,.094.182l-2.537,4.94A.354.354,0,0,1,386.325,310.131Z"
                        transform="translate(-382.13 -304.246)"
                        fill="#fff"
                        opacity="0.3"
                      />
                    </g>
                  </g>
                  <path
                    id="Path_62884"
                    data-name="Path 62884"
                    d="M375.618,315.447c-.6,1.673-1.991,2.908-3.1,2.754s-1.509-1.634-.9-3.308,1.991-2.908,3.1-2.754S376.222,313.774,375.618,315.447Z"
                    transform="translate(-340.388 -289.316)"
                    fill="#fff"
                  />
                </g>
                <path
                  id="Path_62885"
                  data-name="Path 62885"
                  d="M390.91,393.382l6.732,27.592,9.656-3.431-2.857-28.017Z"
                  transform="translate(-246.01 -121.634)"
                  fill="#ebb376"
                />
                <g
                  id="Group_40648"
                  data-name="Group 40648"
                  transform="translate(147.061 294.338)"
                >
                  <path
                    id="Path_62886"
                    data-name="Path 62886"
                    d="M406.962,402.431l-11.692.221a1.082,1.082,0,0,0-1.04.865L392,414.494a1.8,1.8,0,0,0,1.39,2.131,1.818,1.818,0,0,0,.379.039c4.841-.174,9.143-.519,15.174-.623,7.115-.129,5.325.755,13.694.72,5.042-.027,5.858-5.774,3.716-6.016-9.806-1.05-12.619-3.958-16.458-7.388A4.33,4.33,0,0,0,406.962,402.431Z"
                    transform="translate(-391.964 -402.423)"
                    fill="#263238"
                  />
                </g>
                <path
                  id="Path_62887"
                  data-name="Path 62887"
                  d="M406.1,405.778l-1.657-16.251-13.532,3.855,3.892,15.951Z"
                  transform="translate(-246.01 -121.634)"
                  opacity="0.1"
                />
                <path
                  id="Path_62890"
                  data-name="Path 62890"
                  d="M354.208,324.546c4.38,24.174,12.2,19.851,12.2,19.851l-3.426,5.057-9.293,1.183-6.724-12.621L345.229,328Z"
                  transform="translate(-294.001 -189.9)"
                  opacity="0.2"
                />
                <path
                  id="Path_62891"
                  data-name="Path 62891"
                  d="M416.023,371.365l21.6,25.786,7.605-5.729-18.974-28.667Z"
                  transform="translate(-219.628 -149.759)"
                  fill="#ebb376"
                />
                <g
                  id="Group_40649"
                  data-name="Group 40649"
                  transform="translate(212.026 230.554)"
                >
                  <path
                    id="Path_62892"
                    data-name="Path 62892"
                    d="M433.384,375.245l-9.287,7.214a1.08,1.08,0,0,0-.365,1.3l4.4,10.3a1.8,1.8,0,0,0,2.354.964,1.767,1.767,0,0,0,.334-.185c3.886-2.9,7.228-5.623,12.133-9.135,5.783-4.15,4.813-2.405,11.678-7.191,4.134-2.887,1.54-8.079-.361-7.062-8.666,4.708-12.841,3.527-17.949,2.885A4.357,4.357,0,0,0,433.384,375.245Z"
                    transform="translate(-423.646 -371.318)"
                    fill="#263238"
                  />
                </g>
                <path
                  id="Path_62893"
                  data-name="Path 62893"
                  d="M427.8,385.424l9.15-6.51-10.694-16.158-10.234,8.61Z"
                  transform="translate(-219.628 -149.759)"
                  fill="#ebb376"
                  opacity="0.1"
                />
                <path
                  id="Path_62894"
                  data-name="Path 62894"
                  d="M330.664,344.551s-5.606,32.366,5.563,53.292,35.965,24.726,99.675-42.77c0,0,22.406,10.421,76.34,71.255l12-9.289S477.3,340.79,454.606,322.7c-22.915-18.275-73.026,32.778-79.412,29.942-5.684-2.524-8.372-20.134-8.372-20.134Z"
                  transform="translate(-310.78 -196.004)"
                  fill="#1e282d"
                />
                <path
                  id="Path_62896"
                  data-name="Path 62896"
                  d="M416.62,378.169l4.96,4.4,14.161-11.756-2.428-6.307Z"
                  transform="translate(-219.001 -147.924)"
                  fill={primaryColor}
                />
                <path
                  id="Path_62897"
                  data-name="Path 62897"
                  d="M357.849,380.645c12.888-8.863,28.644-22.763,48.018-43.287,0,0,18.422-6.81,24.89,6.351s10.6,108.306,10.6,108.306l-15.346,4.425s-27.426-85.869-27.27-91.535Z"
                  transform="translate(-280.743 -178.291)"
                  fill="#1e282d"
                />
                <path
                  id="Path_62899"
                  data-name="Path 62899"
                  d="M395.754,342.312a13.666,13.666,0,0,0-4.589-5.385c5.479,2.891,13.171,9.878,14.085,26.477v0c-2.182-2.061-4.236-3.951-6.2-5.727C398.038,350.251,396.935,344.715,395.754,342.312Z"
                  transform="translate(-245.743 -176.893)"
                  opacity="0.2"
                />
                <path
                  id="Path_62900"
                  data-name="Path 62900"
                  d="M405.866,337.232a33.343,33.343,0,0,1,6.627-1.517,141.28,141.28,0,0,1-25.158,33.457L357.848,380.52C370.738,371.657,386.494,357.756,405.866,337.232Z"
                  transform="translate(-280.744 -178.166)"
                  opacity="0.2"
                />
                <path
                  id="Path_62901"
                  data-name="Path 62901"
                  d="M389.763,396.645l1.948,6.252L409.52,397.6l.224-6.755Z"
                  transform="translate(-247.215 -120.246)"
                  fill={primaryColor}
                />
                <path
                  id="Path_62902"
                  data-name="Path 62902"
                  d="M390.711,365.37s-4.581,7.45-53.111,14.834c0,0,2.141-14.99-2.973-36.446s-24.069-41.626-5.586-46.828S379.49,281,382.226,292.6s7.757,16.671,7.544,25.925S382.833,334.5,390.711,365.37Z"
                  transform="translate(-319.334 -228.917)"
                  fill="#6d6c68"
                />
                <path
                  id="Path_62903"
                  data-name="Path 62903"
                  d="M389.388,316.835a3.955,3.955,0,0,0-.318-2.881c-.724-1.411-2.028-3.24-3.851-3.057-2.936.3-3.714,2.393-4.458,5.133s-3.076,7.585-.42,9.267C382.877,326.905,386.782,326.021,389.388,316.835Z"
                  transform="translate(-258.414 -204.253)"
                  fill="#ebb376"
                />
                <path
                  id="Path_62904"
                  data-name="Path 62904"
                  d="M330.222,296.777s25.814,1.487,24.3-5.854c0,0-5.024-2.309-4.052-5.036s-12.32.1-17.512-.648c-2.128-.308-.765,2.461-.917,5.424A17.385,17.385,0,0,1,330.222,296.777Z"
                  transform="translate(-309.766 -231.79)"
                  fill="#263238"
                />
                <path
                  id="Path_62905"
                  data-name="Path 62905"
                  d="M328.233,321.355l18.871-.242,6.426-4.372,7.263-3.211.956,2.569s-22.542,26.229-31.267,23.926A122.662,122.662,0,0,0,328.233,321.355Z"
                  transform="translate(-311.856 -201.473)"
                  opacity="0.6"
                />
                <path
                  id="Path_62906"
                  data-name="Path 62906"
                  d="M347.6,335.765s-7.236,2.2-8.473-3.061c-1.782-7.583-7.076-28.691-12.445-36.8-5.858-8.854,5.682,33.465,5.682,33.465l2.561,8.91,4.035,5.477,8.742-6.2Z"
                  transform="translate(-315.229 -221.274)"
                  opacity="0.6"
                />
                <path
                  id="Path_62907"
                  data-name="Path 62907"
                  d="M351.954,289.336s.9,4.94-18.5,4.505C333.452,293.843,356.072,299.246,351.954,289.336Z"
                  transform="translate(-306.375 -226.89)"
                  opacity="0.6"
                />
                <g
                  id="Group_40651"
                  data-name="Group 40651"
                  transform="translate(45.995 75.455)"
                >
                  <g
                    id="Group_40650"
                    data-name="Group 40650"
                    transform="translate(15.943 26.142)"
                  >
                    <path
                      id="Path_62908"
                      data-name="Path 62908"
                      d="M352.185,310.533l-.262-2.1-1.47.88Z"
                      transform="translate(-350.452 -308.429)"
                      fill="#263238"
                    />
                    <path
                      id="Path_62909"
                      data-name="Path 62909"
                      d="M352.185,310.533l-.262-2.1-1.47.88Z"
                      transform="translate(-350.452 -308.429)"
                      fill="#fff"
                      opacity="0.7"
                    />
                  </g>
                  <path
                    id="Path_62910"
                    data-name="Path 62910"
                    d="M342.677,297.962l.248-1.349,1.556-.933,1.306.418,14.1,23.518.308,2.278-1.556.933-1.864-1.345Z"
                    transform="translate(-342.677 -295.68)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62911"
                    data-name="Path 62911"
                    d="M342.677,297.962l.248-1.349,1.556-.933,1.306.418,14.1,23.518.308,2.278-1.556.933-1.864-1.345Z"
                    transform="translate(-342.677 -295.68)"
                    fill="#fff"
                    opacity="0.6"
                  />
                  <rect
                    id="Rectangle_19420"
                    data-name="Rectangle 19420"
                    width="1.815"
                    height="26.694"
                    transform="translate(0.303 2.803) rotate(-30.938)"
                    fill="#fff"
                    opacity="0.5"
                  />
                </g>
                <path
                  id="Path_62912"
                  data-name="Path 62912"
                  d="M325.493,292.726c-6.6,1.852-7.017,10.79-1,32.694s10.4,35.893,22.013,30.625,25.035-19.382,25.035-19.382l-5.815-9.486s-18.927,16.285-22.894,13.175S335.592,289.892,325.493,292.726Z"
                  transform="translate(-320.246 -223.457)"
                  fill="#263238"
                />
                <path
                  id="Path_62913"
                  data-name="Path 62913"
                  d="M341.209,321.719l8-6.736s-1.175-13.45,3.174-13.616c3.568-.135,6.424,4.136,7.06,9.974s-5.953,9.474-5.953,9.474l-7.739,8.584Z"
                  transform="translate(-298.224 -214.253)"
                  fill="#ebb376"
                />
              </g>
            </g>
          </g>
          <g id="Character_2_1_" transform="translate(177.681 95.77)">
            <g
              id="Group_40678"
              data-name="Group 40678"
              transform="translate(0 0)"
            >
              <g
                id="Group_40666"
                data-name="Group 40666"
                transform="translate(75.31)"
              >
                <path
                  id="Path_62914"
                  data-name="Path 62914"
                  d="M262.917,249.168s13.321-8.2,20.254,3.566c4.922,8.354,2.2,16.768,6.093,23.563,6.072,10.593,2.024,15.654-7.085,17.552s-23.727,1.644-21.7-8.982C262.557,274,252.383,249.016,262.917,249.168Z"
                  transform="translate(-192.613 -246.388)"
                  fill="#263238"
                />
                <path
                  id="Path_62915"
                  data-name="Path 62915"
                  d="M274.274,263.839s1.1,15.592,4.015,15.861c0,0-6.862,3.431-13.6,0l-.475-7.168Z"
                  transform="translate(-189.42 -237.347)"
                  fill="#ebb376"
                />
                <g
                  id="Group_40659"
                  data-name="Group 40659"
                  transform="translate(9.255 65.087)"
                >
                  <g
                    id="Group_40654"
                    data-name="Group 40654"
                    transform="translate(5.936 98.58)"
                  >
                    <path
                      id="Path_62916"
                      data-name="Path 62916"
                      d="M230.309,437.441h-5.357l1.7-83.24h7.144Z"
                      transform="translate(-224.952 -354.201)"
                      fill="#407bff"
                    />
                    <path
                      id="Path_62917"
                      data-name="Path 62917"
                      d="M230.309,437.441h-5.357l1.7-83.24h7.144Z"
                      transform="translate(-224.952 -354.201)"
                      fill="#fff"
                      opacity="0.7"
                    />
                  </g>
                  <g
                    id="Group_40656"
                    data-name="Group 40656"
                    transform="translate(95.717 98.58)"
                  >
                    <path
                      id="Path_62919"
                      data-name="Path 62919"
                      d="M287.576,437.441h5.359l-1.7-83.24h-7.144Z"
                      transform="translate(-284.094 -354.201)"
                      fill="#888"
                    />
                  </g>
                  <rect
                    id="Rectangle_19421"
                    data-name="Rectangle 19421"
                    width="87.959"
                    height="7.782"
                    transform="translate(11.609 98.58)"
                    fill="#888"
                  />
                  <path
                    id="Path_62921"
                    data-name="Path 62921"
                    d="M258.614,437.441h5.359l-1.7-83.24h-7.144Z"
                    transform="translate(-203.381 -255.621)"
                    fill="#888"
                  />
                  <g
                    id="Group_40658"
                    data-name="Group 40658"
                    transform="translate(52.853)"
                  >
                    <path
                      id="Path_62923"
                      data-name="Path 62923"
                      d="M304.877,289.263H290.305c-7.65,0-15.77,3.953-17.919,11.3-6.077,20.756-10.675,85.849-10.675,85.849h39.005a9.293,9.293,0,0,0,9.237-8.275l8.172-74.081A13.328,13.328,0,0,0,304.877,289.263Z"
                      transform="translate(-252.826 -289.263)"
                      fill="#263238"
                    />
                    <path
                      id="Path_62924"
                      data-name="Path 62924"
                      d="M304.877,289.263H290.305c-7.65,0-15.77,3.953-17.919,11.3-6.077,20.756-10.675,85.849-10.675,85.849h39.005a9.293,9.293,0,0,0,9.237-8.275l8.172-74.081A13.328,13.328,0,0,0,304.877,289.263Z"
                      transform="translate(-252.826 -289.263)"
                      fill="#fff"
                      opacity="0.6"
                    />
                    <path
                      id="Path_62925"
                      data-name="Path 62925"
                      d="M299.024,289.263H284.452c-7.65,0-15.77,3.953-17.919,11.3-6.077,20.756-10.675,85.849-10.675,85.849h37.649a10.807,10.807,0,0,0,10.742-9.621l8.023-72.733A13.329,13.329,0,0,0,299.024,289.263Z"
                      transform="translate(-255.858 -289.263)"
                      fill="#263238"
                    />
                    <path
                      id="Path_62926"
                      data-name="Path 62926"
                      d="M299.024,289.263H284.452c-7.65,0-15.77,3.953-17.919,11.3-6.077,20.756-10.675,85.849-10.675,85.849h37.649a10.807,10.807,0,0,0,10.742-9.621l8.023-72.733A13.329,13.329,0,0,0,299.024,289.263Z"
                      transform="translate(-255.858 -289.263)"
                      fill="#fff"
                      opacity="0.5"
                    />
                  </g>
                  <path
                    id="Path_62927"
                    data-name="Path 62927"
                    d="M287.569,360.7H230.56a9.518,9.518,0,0,1-9.518-9.518h0a9.518,9.518,0,0,1,9.518-9.518h57.009Z"
                    transform="translate(-221.042 -262.118)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62928"
                    data-name="Path 62928"
                    d="M287.569,360.7H230.56a9.518,9.518,0,0,1-9.518-9.518h0a9.518,9.518,0,0,1,9.518-9.518h57.009Z"
                    transform="translate(-221.042 -262.118)"
                    fill="#fff"
                    opacity="0.5"
                  />
                  <path
                    id="Path_62929"
                    data-name="Path 62929"
                    d="M303.5,360.7H266.675a9.107,9.107,0,0,1-9.107-9.107v-.823a9.107,9.107,0,0,1,9.107-9.107H303.5a9.518,9.518,0,0,1,9.518,9.518h0A9.519,9.519,0,0,1,303.5,360.7Z"
                    transform="translate(-202.119 -262.118)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62930"
                    data-name="Path 62930"
                    d="M303.5,360.7H266.675a9.107,9.107,0,0,1-9.107-9.107v-.823a9.107,9.107,0,0,1,9.107-9.107H303.5a9.518,9.518,0,0,1,9.518,9.518h0A9.519,9.519,0,0,1,303.5,360.7Z"
                    transform="translate(-202.119 -262.118)"
                    fill="#fff"
                    opacity="0.6"
                  />
                </g>
                <path
                  id="Path_62931"
                  data-name="Path 62931"
                  d="M264.808,288.025s1.272,13.846-5.269,19.7c-5.954,5.333-15.56,7.962-15.56,7.962l-8.471-2.468a2.062,2.062,0,0,0-2.185.642l-3.789,4.594a2.172,2.172,0,0,0,.433,3.085h0a2.224,2.224,0,0,0,1.623.455l4.386-.536a36.351,36.351,0,0,0,5.344.645,26.8,26.8,0,0,0,3.986-1.116s15.106-1.3,21.549-7.744,8.059-19.812,8.059-19.812Z"
                  transform="translate(-207.626 -224.817)"
                  fill="#ebb376"
                />
                <path
                  id="Path_62932"
                  data-name="Path 62932"
                  d="M223.3,385.4l.985,30.3h6.78l3.173-30.842Z"
                  transform="translate(-210.616 -174.656)"
                  fill="#ebb376"
                />
                <path
                  id="Path_62933"
                  data-name="Path 62933"
                  d="M228.509,403.123l7.731.04a.719.719,0,0,1,.7.563l1.6,7.272a1.2,1.2,0,0,1-.9,1.431,1.265,1.265,0,0,1-.252.03c-3.22-.064-6.083-.246-10.092-.25-4.732-.009-3.533.559-9.095.625-3.352.036-3.956-3.774-2.535-3.959,6.5-.8,8.387-2.784,10.9-5.107A2.877,2.877,0,0,1,228.509,403.123Z"
                  transform="translate(-214.945 -165.191)"
                  fill="#263238"
                />
                <path
                  id="Path_62934"
                  data-name="Path 62934"
                  d="M231.571,403.32l.762-7.416H223.65l.241,7.416Z"
                  transform="translate(-210.436 -168.93)"
                  fill="#263238"
                  opacity="0.1"
                />
                <path
                  id="Path_62935"
                  data-name="Path 62935"
                  d="M302.7,310.636s21.134,48.009.836,48.009h-58.57s-2.534,12.768-11.659,82.945h-9.8s-1.638-82.2,3.778-94.454c4.245-9.608,31.441-16.476,44.315-19a8.244,8.244,0,0,0,6.588-6.977l2.859-11.794Z"
                  transform="translate(-210.63 -213.76)"
                  fill="#263238"
                />
                <path
                  id="Path_62936"
                  data-name="Path 62936"
                  d="M302.7,310.636s21.134,48.009.836,48.009h-58.57s-2.534,12.768-11.659,82.945h-9.8s-1.638-82.2,3.778-94.454c4.245-9.608,31.441-16.476,44.315-19a8.244,8.244,0,0,0,6.588-6.977l2.859-11.794Z"
                  transform="translate(-210.63 -213.76)"
                  opacity="0.2"
                />
                <g
                  id="Group_40660"
                  data-name="Group 40660"
                  transform="translate(11.002 226.152)"
                >
                  <path
                    id="Path_62937"
                    data-name="Path 62937"
                    d="M222.193,395.362l.785,5.331h11.639l1.076-5.331Z"
                    transform="translate(-222.193 -395.362)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62938"
                    data-name="Path 62938"
                    d="M222.193,395.362l.785,5.331h11.639l1.076-5.331Z"
                    transform="translate(-222.193 -395.362)"
                    fill="#fff"
                    opacity="0.2"
                  />
                </g>
                <g
                  id="Group_40661"
                  data-name="Group 40661"
                  transform="translate(33.054 210.206)"
                >
                  <path
                    id="Path_62939"
                    data-name="Path 62939"
                    d="M236.719,385.406l1.132,29.892,6.494-.008L249,384.858Z"
                    transform="translate(-236.719 -384.858)"
                    fill="#ebb376"
                  />
                  <path
                    id="Path_62940"
                    data-name="Path 62940"
                    d="M245.091,403.32l1.134-7.416h-9.1l.281,7.416Z"
                    transform="translate(-236.509 -379.135)"
                    fill="#263238"
                    opacity="0.1"
                  />
                </g>
                <path
                  id="Path_62941"
                  data-name="Path 62941"
                  d="M242.194,403.123l7.731.04a.719.719,0,0,1,.7.563l1.6,7.272a1.2,1.2,0,0,1-.9,1.431,1.278,1.278,0,0,1-.252.03c-3.22-.064-6.083-.246-10.092-.25-4.732-.009-3.533.559-9.095.625-3.352.036-3.956-3.774-2.535-3.959,6.5-.8,8.387-2.784,10.9-5.107A2.877,2.877,0,0,1,242.194,403.123Z"
                  transform="translate(-207.856 -165.191)"
                  fill="#263238"
                />
                <path
                  id="Path_62942"
                  data-name="Path 62942"
                  d="M307.092,310.953s1.518,0,3.8,11.337c2.9,14.406,7.1,35.837-6.727,35.837H259.346s-2.19,5.205-11.728,82.945h-9.8s-5.441-83.185-.024-95.442c4.172-9.441,24.916-13.758,36.324-15.244a6.773,6.773,0,0,0,6.033-6.326c.088-3.423-.407-13.691-.407-13.691Z"
                  transform="translate(-204.35 -213.242)"
                  fill="#263238"
                />
                <g
                  id="Group_40662"
                  data-name="Group 40662"
                  transform="translate(31.514 226.152)"
                >
                  <path
                    id="Path_62943"
                    data-name="Path 62943"
                    d="M235.7,395.362l1.126,5.331h11.3l1.076-5.331Z"
                    transform="translate(-235.705 -395.362)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62944"
                    data-name="Path 62944"
                    d="M235.7,395.362l1.126,5.331h11.3l1.076-5.331Z"
                    transform="translate(-235.705 -395.362)"
                    fill="#fff"
                    opacity="0.2"
                  />
                </g>
                <path
                  id="Path_62945"
                  data-name="Path 62945"
                  d="M260.375,274.357c-5.46-.821-8.554,12.618-8.833,25.315l12.96,3.039S270.593,275.893,260.375,274.357Z"
                  transform="translate(-195.987 -231.917)"
                  fill={primaryColor}
                />
                <path
                  id="Path_62947"
                  data-name="Path 62947"
                  d="M261.927,335.757a185.436,185.436,0,0,0-2.087-20.378c-2.055-13.063-5.573-27.738-4.38-37.03a4.823,4.823,0,0,1,4.952-4.24h35.445a4.033,4.033,0,0,1,3.936,4.314c-1.224,9.952-4.293,34.735.4,58.13C300.193,336.551,273.118,338.71,261.927,335.757Z"
                  transform="translate(-194.081 -232.027)"
                  fill={primaryColor}
                />
                <g
                  id="Group_40663"
                  data-name="Group 40663"
                  transform="translate(56.284 42.351)"
                >
                  <path
                    id="Path_62948"
                    data-name="Path 62948"
                    d="M294.336,285.8s2.353,16.12-4.753,20.662-22.646,9.256-22.646,9.256l-9.6-2.036a1.205,1.205,0,0,0-1.287.531l-3.848,6.223a1.272,1.272,0,0,0,.131,1.48h0a1.329,1.329,0,0,0,1.152.48l5.822-.607a27.329,27.329,0,0,0,4.038.679,32.865,32.865,0,0,0,4.991-1.175s22.211-2.162,28.993-8.944,7.648-20.854,7.648-20.854Z"
                    transform="translate(-252.022 -268.323)"
                    fill="#ebb376"
                  />
                  <path
                    id="Path_62949"
                    data-name="Path 62949"
                    d="M284.833,274.318c-6.889-.821-5.066,14.581-5.9,25.373l12.876,1.451S295.075,275.538,284.833,274.318Z"
                    transform="translate(-238.082 -274.286)"
                    fill={primaryColor}
                  />
                </g>
                <path
                  id="Path_62951"
                  data-name="Path 62951"
                  d="M263.845,277.326s-1.33,11.5,13.863,1.245a2.367,2.367,0,0,0,.824-2.95,11.591,11.591,0,0,1-1.1-4.541,1.292,1.292,0,0,0-2.01-1.034A15.813,15.813,0,0,1,265.1,272.7a1.321,1.321,0,0,0-1.391,1.688A5.946,5.946,0,0,1,263.845,277.326Z"
                  transform="translate(-189.711 -234.245)"
                  fill="#263238"
                />
                <path
                  id="Path_62953"
                  data-name="Path 62953"
                  d="M274.473,266.086h0c-.135-1.354-.2-2.248-.2-2.248l-10.057,8.692.25,3.781C267.37,276.1,271.608,274.219,274.473,266.086Z"
                  transform="translate(-189.42 -237.348)"
                  opacity="0.1"
                />
                <g
                  id="Group_40665"
                  data-name="Group 40665"
                  transform="translate(59.835 2.779)"
                >
                  <path
                    id="Path_62954"
                    data-name="Path 62954"
                    d="M279.832,259.413c.811,8.881,1.348,12.621-2.4,17.817-5.638,7.82-16.717,6.878-20.172-1.58-3.106-7.613-3.914-20.848,4.152-25.674a12.164,12.164,0,0,1,18.42,9.436Z"
                    transform="translate(-254.004 -248.218)"
                    fill="#ebb376"
                  />
                  <path
                    id="Path_62955"
                    data-name="Path 62955"
                    d="M259.646,261.124a19.315,19.315,0,0,1-1.723,5.013,3.106,3.106,0,0,0,2.625.03Z"
                    transform="translate(-252.516 -241.533)"
                    fill="#d58745"
                  />
                  <path
                    id="Path_62956"
                    data-name="Path 62956"
                    d="M264.025,257.958a.415.415,0,0,0,.147-.109.355.355,0,0,0-.062-.5l-.006,0a4.134,4.134,0,0,0-3.734-.767.366.366,0,0,0-.214.452.354.354,0,0,0,.443.217,3.461,3.461,0,0,1,3.082.663A.351.351,0,0,0,264.025,257.958Z"
                    transform="translate(-251.369 -243.967)"
                    fill="#2e353a"
                  />
                  <path
                    id="Path_62957"
                    data-name="Path 62957"
                    d="M254.689,259.506a.387.387,0,0,1-.173-.059.354.354,0,0,1-.094-.49l0-.006a4.132,4.132,0,0,1,3.309-1.89.362.362,0,0,1,.343.363.354.354,0,0,1-.354.345A3.466,3.466,0,0,0,255,259.357.354.354,0,0,1,254.689,259.506Z"
                    transform="translate(-254.361 -243.638)"
                    fill="#2e353a"
                  />
                  <g
                    id="Group_40664"
                    data-name="Group 40664"
                    transform="translate(1.227 16.188)"
                  >
                    <path
                      id="Path_62958"
                      data-name="Path 62958"
                      d="M262.821,260.144c.129.709-.146,1.353-.618,1.442s-.944-.422-1.067-1.143.147-1.353.609-1.438S262.689,259.427,262.821,260.144Z"
                      transform="translate(-252.093 -258.823)"
                      fill="#2e353a"
                    />
                    <path
                      id="Path_62959"
                      data-name="Path 62959"
                      d="M257.51,261.1c.129.709-.146,1.353-.609,1.439s-.944-.422-1.076-1.14.147-1.353.609-1.438S257.387,260.377,257.51,261.1Z"
                      transform="translate(-254.846 -258.329)"
                      fill="#2e353a"
                    />
                    <path
                      id="Path_62960"
                      data-name="Path 62960"
                      d="M256.968,260.02l-1.8-.184S256.291,261.011,256.968,260.02Z"
                      transform="translate(-255.169 -258.388)"
                      fill="#2e353a"
                    />
                    <path
                      id="Path_62961"
                      data-name="Path 62961"
                      d="M262.28,259.066l-1.8-.184S261.6,260.057,262.28,259.066Z"
                      transform="translate(-252.417 -258.882)"
                      fill="#2e353a"
                    />
                  </g>
                  <path
                    id="Path_62962"
                    data-name="Path 62962"
                    d="M275.594,261.163a6.5,6.5,0,0,1-2.518,4.292c-1.835,1.362-3.566-.079-3.742-2.238-.158-1.937.607-4.99,2.781-5.5a2.943,2.943,0,0,1,3.479,3.449Z"
                    transform="translate(-246.615 -243.331)"
                    fill="#ebb376"
                  />
                  <path
                    id="Path_62963"
                    data-name="Path 62963"
                    d="M261.6,267.649a4.6,4.6,0,0,1-.782.178.157.157,0,0,1-.184-.124.011.011,0,0,0,0-.006.166.166,0,0,1,.143-.179,4.317,4.317,0,0,0,3.212-2.191.159.159,0,0,1,.29.132A4.44,4.44,0,0,1,261.6,267.649Z"
                    transform="translate(-251.112 -239.404)"
                    fill="#263238"
                  />
                </g>
                <path
                  id="Path_62964"
                  data-name="Path 62964"
                  d="M268.57,253.675s-2.426,3.8-.551,6.452-10.9-2.9-14.191,2.912c0,0-4.169-17.966,14.74-15.562v6.2Z"
                  transform="translate(-195.004 -245.939)"
                  fill="#263238"
                />
                <path
                  id="Path_62965"
                  data-name="Path 62965"
                  d="M263.309,252.609s-1.413,7.2,3.267,9.418,4.554,8.166,8.77,7.167c6.075-1.439,1.731-19.874-8.116-21.868C259.933,245.852,263.309,252.609,263.309,252.609Z"
                  transform="translate(-190.294 -246.011)"
                  fill="#263238"
                />
              </g>
              <g
                id="Group_40674"
                data-name="Group 40674"
                transform="translate(0 100.329)"
              >
                <g
                  id="Group_40667"
                  data-name="Group 40667"
                  transform="translate(8.137 9.286)"
                >
                  <path
                    id="Path_62966"
                    data-name="Path 62966"
                    d="M178.224,457.141H172.99L170.7,318.595h9.822Z"
                    transform="translate(-170.696 -318.595)"
                    fill="#464c4f"
                  />
                  <path
                    id="Path_62967"
                    data-name="Path 62967"
                    d="M178.224,457.141H172.99L170.7,318.595h9.822Z"
                    transform="translate(-170.696 -318.595)"
                    fill="#464c4f"
                    opacity="0.7"
                  />
                </g>
                <g
                  id="Group_40668"
                  data-name="Group 40668"
                  transform="translate(65.92 9.286)"
                >
                  <path
                    id="Path_62968"
                    data-name="Path 62968"
                    d="M216.288,457.141h-5.236L208.76,318.595h9.822Z"
                    transform="translate(-208.76 -318.595)"
                    fill="#464c4f"
                  />
                  <path
                    id="Path_62969"
                    data-name="Path 62969"
                    d="M216.288,457.141h-5.236L208.76,318.595h9.822Z"
                    transform="translate(-208.76 -318.595)"
                    fill="#464c4f"
                    opacity="0.4"
                  />
                </g>
                <g
                  id="Group_40669"
                  data-name="Group 40669"
                  transform="translate(13.048 6.965)"
                >
                  <rect
                    id="Rectangle_19423"
                    data-name="Rectangle 19423"
                    width="98.783"
                    height="10.836"
                    fill="#464c4f"
                  />
                  <rect
                    id="Rectangle_19424"
                    data-name="Rectangle 19424"
                    width="98.783"
                    height="10.836"
                    fill="#464c4f"
                    opacity="0.3"
                  />
                </g>
                <g
                  id="Group_40670"
                  data-name="Group 40670"
                  transform="translate(111.831 6.965)"
                >
                  <rect
                    id="Rectangle_19425"
                    data-name="Rectangle 19425"
                    width="57.929"
                    height="10.836"
                    fill="#464c4f"
                  />
                  <rect
                    id="Rectangle_19426"
                    data-name="Rectangle 19426"
                    width="57.929"
                    height="10.836"
                    fill="#464c4f"
                    opacity="0.5"
                  />
                </g>
                <g
                  id="Group_40671"
                  data-name="Group 40671"
                  transform="translate(164.703 9.286)"
                >
                  <path
                    id="Path_62970"
                    data-name="Path 62970"
                    d="M281.362,457.141h-5.236l-2.294-138.546h9.823Z"
                    transform="translate(-273.832 -318.595)"
                    fill="#464c4f"
                  />
                  <path
                    id="Path_62971"
                    data-name="Path 62971"
                    d="M281.362,457.141h-5.236l-2.294-138.546h9.823Z"
                    transform="translate(-273.832 -318.595)"
                    fill="#464c4f"
                    opacity="0.4"
                  />
                </g>
                <path
                  id="Path_62972"
                  data-name="Path 62972"
                  d="M308.53,321.764H233.643a4.02,4.02,0,0,1-4.02-4.02V316.5a4.02,4.02,0,0,1,4.02-4.02H308.53a4.02,4.02,0,0,1,4.02,4.02v1.246A4.019,4.019,0,0,1,308.53,321.764Z"
                  transform="translate(-132.032 -312.478)"
                  fill="#464c4f"
                />
                <path
                  id="Path_62973"
                  data-name="Path 62973"
                  d="M308.53,321.764H233.643a4.02,4.02,0,0,1-4.02-4.02V316.5a4.02,4.02,0,0,1,4.02-4.02H308.53a4.02,4.02,0,0,1,4.02,4.02v1.246A4.019,4.019,0,0,1,308.53,321.764Z"
                  transform="translate(-132.032 -312.478)"
                  fill="#464c4f"
                  opacity="0.6"
                />
                <g id="Group_40672" data-name="Group 40672">
                  <path
                    id="Path_62974"
                    data-name="Path 62974"
                    d="M271.814,321.764H169.356a4.02,4.02,0,0,1-4.02-4.02V316.5a4.02,4.02,0,0,1,4.02-4.02H271.814a4.02,4.02,0,0,1,4.02,4.02v1.246A4.018,4.018,0,0,1,271.814,321.764Z"
                    transform="translate(-165.336 -312.478)"
                    fill="#464c4f"
                  />
                  <path
                    id="Path_62975"
                    data-name="Path 62975"
                    d="M271.814,321.764H169.356a4.02,4.02,0,0,1-4.02-4.02V316.5a4.02,4.02,0,0,1,4.02-4.02H271.814a4.02,4.02,0,0,1,4.02,4.02v1.246A4.018,4.018,0,0,1,271.814,321.764Z"
                    transform="translate(-165.336 -312.478)"
                    fill="#464c4f"
                    opacity="0.5"
                  />
                </g>
                <g
                  id="Group_40673"
                  data-name="Group 40673"
                  transform="translate(106.92 9.286)"
                >
                  <path
                    id="Path_62976"
                    data-name="Path 62976"
                    d="M243.3,457.141h-5.236l-2.294-138.546h9.823Z"
                    transform="translate(-235.768 -318.595)"
                    fill="#464c4f"
                  />
                </g>
                <path
                  id="Path_62977"
                  data-name="Path 62977"
                  d="M243.3,457.141h-5.236l-2.294-138.546h9.823Z"
                  transform="translate(-128.848 -309.309)"
                  fill="#464c4f"
                  opacity="0.7"
                />
              </g>
              <g
                id="Group_40677"
                data-name="Group 40677"
                transform="translate(46.349 55.173)"
              >
                <g
                  id="Group_40675"
                  data-name="Group 40675"
                  transform="translate(46.805 0.001)"
                >
                  <path
                    id="Path_62978"
                    data-name="Path 62978"
                    d="M234.089,313.531a1.544,1.544,0,0,1,0-3.088h42.052a1.544,1.544,0,0,1,0,3.088Z"
                    transform="translate(-223.672 -268.378)"
                    fill="#474747"
                  />
                  <path
                    id="Path_62980"
                    data-name="Path 62980"
                    d="M240.687,325.217l-5.6-39.831a3.158,3.158,0,0,0-3.026-2.654H226.7v45.138h11.706A2.254,2.254,0,0,0,240.687,325.217Z"
                    transform="translate(-226.7 -282.733)"
                    fill="#474747"
                  />
                </g>
                <g id="Group_40676" data-name="Group 40676">
                  <path
                    id="Path_62981"
                    data-name="Path 62981"
                    d="M252.065,327.87H204.518a3.156,3.156,0,0,1-3.025-2.654l-5.6-39.831a2.253,2.253,0,0,1,2.28-2.654h47.547a3.156,3.156,0,0,1,3.025,2.654l5.6,39.831A2.25,2.25,0,0,1,252.065,327.87Z"
                    transform="translate(-195.868 -282.732)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62982"
                    data-name="Path 62982"
                    d="M252.065,327.87H204.518a3.156,3.156,0,0,1-3.025-2.654l-5.6-39.831a2.253,2.253,0,0,1,2.28-2.654h47.547a3.156,3.156,0,0,1,3.025,2.654l5.6,39.831A2.25,2.25,0,0,1,252.065,327.87Z"
                    transform="translate(-195.868 -282.732)"
                    fill="#fff"
                    opacity="0.7"
                  />
                </g>
                <path
                  id="Path_62983"
                  data-name="Path 62983"
                  d="M218.331,297.713a2.06,2.06,0,0,1-2.084,2.426,2.885,2.885,0,0,1-2.766-2.426,2.06,2.06,0,0,1,2.084-2.426A2.885,2.885,0,0,1,218.331,297.713Z"
                  transform="translate(-186.755 -276.228)"
                  fill="#fff"
                  opacity="0.7"
                />
              </g>
            </g>
          </g>
          <g id="Character_1" transform="translate(19.958 80.089)">
            <g
              id="Group_40694"
              data-name="Group 40694"
              transform="translate(0 0)"
            >
              <path
                id="Path_62984"
                data-name="Path 62984"
                d="M153.3,328.928c-5.714,33.326,34.082,15.852,49.933,16.248a8.973,8.973,0,0,1,2.96.6l4.9,21.137-4.756,21.9-11.1,17.537H126.181L76.248,372.557l-12.682-39.63,3.566-64.2,1.585-10.3s1.585,12.682,36.459,9.511,62.212-14.409,70.145-3.17C184.835,278.24,157.072,306.892,153.3,328.928Z"
                transform="translate(-60.336 -224.471)"
                fill="#343434"
              />
              <path
                id="Path_62985"
                data-name="Path 62985"
                d="M180.534,341.3v12.474L160.62,361.8l-39.234-2.081-10.314-13.078,4.37-6.836h25.264Z"
                transform="translate(-35.725 -182.309)"
                opacity="0.2"
              />
              <rect
                id="Rectangle_19427"
                data-name="Rectangle 19427"
                width="11.993"
                height="54.589"
                transform="translate(69.351 199.789)"
                fill="#263238"
              />
              <rect
                id="Rectangle_19428"
                data-name="Rectangle 19428"
                width="11.993"
                height="54.589"
                transform="translate(69.351 199.789)"
                fill="#666"
                opacity="0.5"
              />
              <path
                id="Path_62986"
                data-name="Path 62986"
                d="M135.957,400.357h-18.2L80.6,407.387v6.2h7.651l29.513-5.583h18.2l29.513,5.583h7.651v-6.2Z"
                transform="translate(-51.512 -150.941)"
                fill="#263238"
              />
              <path
                id="Path_62987"
                data-name="Path 62987"
                d="M135.957,400.357h-18.2L80.6,407.387v6.2h7.651l29.513-5.583h18.2l29.513,5.583h7.651v-6.2Z"
                transform="translate(-51.512 -150.941)"
                fill="#666"
                opacity="0.3"
              />
              <g
                id="Group_40679"
                data-name="Group 40679"
                transform="translate(112.16 261.617)"
              >
                <path
                  id="Path_62988"
                  data-name="Path 62988"
                  d="M137.119,412.116h7.651a1.862,1.862,0,0,0,0-3.722h-7.651a1.862,1.862,0,0,0,0,3.722Z"
                  transform="translate(-135.322 -408.394)"
                  fill={primaryColor}
                />
              </g>
              <g
                id="Group_40680"
                data-name="Group 40680"
                transform="translate(27.288 261.617)"
              >
                <path
                  id="Path_62989"
                  data-name="Path 62989"
                  d="M81.212,412.116h7.651a1.862,1.862,0,0,0,0-3.722H81.212a1.862,1.862,0,0,0,0,3.722Z"
                  transform="translate(-79.414 -408.394)"
                  fill={primaryColor}
                />
              </g>
              <rect
                id="Rectangle_19429"
                data-name="Rectangle 19429"
                width="11.993"
                height="12.355"
                transform="translate(69.351 199.789)"
                opacity="0.2"
              />
              <path
                id="Path_62990"
                data-name="Path 62990"
                d="M178.267,351.171H106.51V335.7h71.757A7.738,7.738,0,0,1,186,343.435h0A7.737,7.737,0,0,1,178.267,351.171Z"
                transform="translate(-38.088 -184.439)"
                fill={primaryColor}
              />
              <g
                id="Group_40692"
                data-name="Group 40692"
                transform="translate(23.366)"
              >
                <path
                  id="Path_62992"
                  data-name="Path 62992"
                  d="M115.836,272.2s9.189,25.768,16.7,26.351,16.712-13.245,16.712-13.245L153,275.564l7.552-.63v12.227l-7.753,3.9s-11.848,19.474-21.051,18.991-18.495-14.73-20.375-21.984C110.338,284.078,111.026,275.766,115.836,272.2Z"
                  transform="translate(-59.15 -217.331)"
                  fill="#ffc3bd"
                />
                <g
                  id="Group_40681"
                  data-name="Group 40681"
                  transform="translate(95.005 47.473)"
                >
                  <path
                    id="Path_62993"
                    data-name="Path 62993"
                    d="M147.418,294.1l2.722-22.5-10.412-.7-.314,22.662Z"
                    transform="translate(-139.413 -265.483)"
                    fill="#263238"
                  />
                  <path
                    id="Path_62994"
                    data-name="Path 62994"
                    d="M147.418,294.1l2.722-22.5-10.412-.7-.314,22.662Z"
                    transform="translate(-139.413 -265.483)"
                    fill="#fff"
                    opacity="0.5"
                  />
                  <rect
                    id="Rectangle_19430"
                    data-name="Rectangle 19430"
                    width="10.437"
                    height="3.241"
                    transform="translate(0.517 2.161) rotate(3.848)"
                    fill={primaryColor}
                  />
                  <path
                    id="Path_62995"
                    data-name="Path 62995"
                    d="M150.175,270.208l-10.412-.7.109-1.626a.592.592,0,0,1,.63-.551l9.231.621a.592.592,0,0,1,.551.63Z"
                    transform="translate(-139.232 -267.33)"
                    fill="#263238"
                  />
                </g>
                <g
                  id="Group_40682"
                  data-name="Group 40682"
                  transform="translate(48.618 52.124)"
                >
                  <path
                    id="Path_62996"
                    data-name="Path 62996"
                    d="M114.515,295.826s-9.852-16.266-3.557-23.976,15.908,17.71,15.908,17.71Z"
                    transform="translate(-108.856 -270.394)"
                    fill={primaryColor}
                  />
                  <path
                    id="Path_62997"
                    data-name="Path 62997"
                    d="M114.515,295.826s-9.852-16.266-3.557-23.976,15.908,17.71,15.908,17.71Z"
                    transform="translate(-108.856 -270.394)"
                    fill={primaryColor}
                    opacity="0.3"
                  />
                </g>
                <g
                  id="Group_40683"
                  data-name="Group 40683"
                  transform="translate(0 48.899)"
                >
                  <path
                    id="Path_63000"
                    data-name="Path 63000"
                    d="M81.739,359.133s-12.351-43.21,2.127-86.183c0,0,18.789-8.743,45.581-2.33a5.643,5.643,0,0,1,4.147,6.9c-2.681,10.421-6.825,35.272,3.182,66.681A120.52,120.52,0,0,1,81.739,359.133Z"
                    transform="translate(-76.83 -268.269)"
                    fill={primaryColor}
                  />
                </g>
                <path
                  id="Path_63002"
                  data-name="Path 63002"
                  d="M95.538,273.656l9.07,7.857,5.268-4.665c-1.992-1.483-1.445-4.829-.334-8.442L96.678,258.251C97.331,263.019,97.824,269.565,95.538,273.656Z"
                  transform="translate(-67.138 -224.56)"
                  fill="#ffc3bd"
                />
                <g
                  id="Group_40685"
                  data-name="Group 40685"
                  transform="translate(3.779 113.373)"
                >
                  <path
                    id="Path_63003"
                    data-name="Path 63003"
                    d="M140.059,335.207l16.718,6.805-1.888,7.07-17.846-3.677Z"
                    transform="translate(-49.416 -298.065)"
                    fill="#ffc3bd"
                  />
                  <g
                    id="Group_40684"
                    data-name="Group 40684"
                    transform="translate(20.023)"
                  >
                    <path
                      id="Path_63004"
                      data-name="Path 63004"
                      d="M106.039,323.756s80.021-27.72,86.62-2.251-54.044,43.037-85.817,41.967S106.039,323.756,106.039,323.756Z"
                      transform="translate(-92.51 -310.74)"
                      fill="#263238"
                    />
                    <path
                      id="Path_63005"
                      data-name="Path 63005"
                      d="M106.039,323.756s80.021-27.72,86.62-2.251-54.044,43.037-85.817,41.967S106.039,323.756,106.039,323.756Z"
                      transform="translate(-92.51 -310.74)"
                      opacity="0.3"
                    />
                  </g>
                  <path
                    id="Path_63006"
                    data-name="Path 63006"
                    d="M154.8,321.452,115.969,346.2l6.2,10.169s-3.754,1.248-8.947-11.176l24.032-15.886s-7.527-.755-7.332-1.936c.316-1.919,16.828-5.6,24.365-7.188A.694.694,0,0,1,154.8,321.452Z"
                    transform="translate(-61.757 -305.856)"
                    opacity="0.7"
                  />
                  <path
                    id="Path_63007"
                    data-name="Path 63007"
                    d="M123.974,337.731l6.731,11.414a127.749,127.749,0,0,1-25.175,2.063,22.935,22.935,0,0,1-8.128-1.533l-2.362-4.527,5.092-10.734Z"
                    transform="translate(-71.176 -298.476)"
                    opacity="0.7"
                  />
                  <path
                    id="Path_63008"
                    data-name="Path 63008"
                    d="M117.132,337.754l-7.56,6.336,3.472,5.391,11.508-1.8Z"
                    transform="translate(-63.647 -296.746)"
                    fill="#ffc3bd"
                  />
                  <path
                    id="Path_63009"
                    data-name="Path 63009"
                    d="M124.684,348.667l-7.9-12.448-3.564,2.546,6.831,10.746Z"
                    transform="translate(-61.757 -297.541)"
                    fill="#263238"
                  />
                  <path
                    id="Path_63010"
                    data-name="Path 63010"
                    d="M124.684,348.667l-7.9-12.448-3.564,2.546,6.831,10.746Z"
                    transform="translate(-61.757 -297.541)"
                    fill="#fff"
                    opacity="0.3"
                  />
                  <path
                    id="Path_63011"
                    data-name="Path 63011"
                    d="M84.746,348.162c-4.3-7.3-12.611-29.258,7.361-33.08s85.571,33.08,85.571,33.08l-3.054,9.6-62.117-10.247s17.271,15.628-1.62,13.685C95.9,359.663,88.93,355.256,84.746,348.162Z"
                    transform="translate(-79.32 -308.635)"
                    fill="#263238"
                  />
                  <path
                    id="Path_63012"
                    data-name="Path 63012"
                    d="M144.372,335.207l-3.883,12.538,3.883.542,3.5-10.831Z"
                    transform="translate(-47.63 -298.065)"
                    fill="#263238"
                  />
                  <path
                    id="Path_63013"
                    data-name="Path 63013"
                    d="M144.372,335.207l-3.883,12.538,3.883.542,3.5-10.831Z"
                    transform="translate(-47.63 -298.065)"
                    fill="#fff"
                    opacity="0.3"
                  />
                  <path
                    id="Path_63014"
                    data-name="Path 63014"
                    d="M117.335,348.289,114.61,340a.7.7,0,0,0-.735-.48l-7.237.718a1.168,1.168,0,0,0-1.057,1.269,1.186,1.186,0,0,0,.049.243c1.034,2.972,2.071,5.576,3.288,9.3,1.442,4.392.55,3.449,2.172,8.636.981,3.124,4.7,2.532,4.443,1.155-1.224-6.286.393-7.511,1.788-10.549A2.813,2.813,0,0,0,117.335,348.289Z"
                    transform="translate(-65.717 -295.833)"
                    fill="#263238"
                  />
                  <path
                    id="Path_63015"
                    data-name="Path 63015"
                    d="M150.035,342.7l-2.81,8.516a.721.721,0,0,0,.314.846l6.42,3.826a1.2,1.2,0,0,0,1.649-.4,1.177,1.177,0,0,0,.108-.231c.959-3.088,1.693-5.873,2.959-9.694,1.489-4.51,1.652-3.188,3.476-8.466,1.1-3.182-2.342-4.964-2.968-3.669-2.827,5.943-4.911,5.969-7.92,7.628A2.9,2.9,0,0,0,150.035,342.7Z"
                    transform="translate(-44.159 -299.209)"
                    fill="#263238"
                  />
                </g>
                <g
                  id="Group_40689"
                  data-name="Group 40689"
                  transform="translate(42.958 95.159)"
                >
                  <g
                    id="Group_40686"
                    data-name="Group 40686"
                    transform="translate(16.655 30.334)"
                  >
                    <path
                      id="Path_63016"
                      data-name="Path 63016"
                      d="M155.178,321.8H119.172a3.072,3.072,0,0,1-3.073-3.073h42.15A3.07,3.07,0,0,1,155.178,321.8Z"
                      transform="translate(-116.099 -318.724)"
                      fill="#263238"
                    />
                    <path
                      id="Path_63017"
                      data-name="Path 63017"
                      d="M155.178,321.8H119.172a3.072,3.072,0,0,1-3.073-3.073h42.15A3.07,3.07,0,0,1,155.178,321.8Z"
                      transform="translate(-116.099 -318.724)"
                      fill="#fff"
                      opacity="0.2"
                    />
                  </g>
                  <path
                    id="Path_63018"
                    data-name="Path 63018"
                    d="M134.357,321.8H108.2a3.072,3.072,0,0,1-3.073-3.073h32.3A3.072,3.072,0,0,1,134.357,321.8Z"
                    transform="translate(-105.128 -288.39)"
                    fill="#263238"
                  />
                  <path
                    id="Path_63019"
                    data-name="Path 63019"
                    d="M134.357,321.8H108.2a3.072,3.072,0,0,1-3.073-3.073h32.3A3.072,3.072,0,0,1,134.357,321.8Z"
                    transform="translate(-105.128 -288.39)"
                    fill="#fff"
                    opacity="0.5"
                  />
                  <g
                    id="Group_40687"
                    data-name="Group 40687"
                    transform="translate(31.561)"
                  >
                    <path
                      id="Path_63020"
                      data-name="Path 63020"
                      d="M150.346,331.209h-23.7a.727.727,0,0,1-.686-.967L136.5,300.128a2.068,2.068,0,0,1,1.952-1.386h23.7a.728.728,0,0,1,.686.969L152.3,329.824A2.068,2.068,0,0,1,150.346,331.209Z"
                      transform="translate(-125.919 -298.742)"
                      fill="#263238"
                    />
                    <path
                      id="Path_63021"
                      data-name="Path 63021"
                      d="M150.346,331.209h-23.7a.727.727,0,0,1-.686-.967L136.5,300.128a2.068,2.068,0,0,1,1.952-1.386h23.7a.728.728,0,0,1,.686.969L152.3,329.824A2.068,2.068,0,0,1,150.346,331.209Z"
                      transform="translate(-125.919 -298.742)"
                      fill="#fff"
                      opacity="0.5"
                    />
                  </g>
                  <g
                    id="Group_40688"
                    data-name="Group 40688"
                    transform="translate(32.489)"
                  >
                    <path
                      id="Path_63022"
                      data-name="Path 63022"
                      d="M150.957,331.209h-23.7a.727.727,0,0,1-.686-.967l10.541-30.114a2.068,2.068,0,0,1,1.952-1.386h23.7a.728.728,0,0,1,.686.969l-10.541,30.114A2.068,2.068,0,0,1,150.957,331.209Z"
                      transform="translate(-126.53 -298.742)"
                      fill="#263238"
                    />
                    <path
                      id="Path_63023"
                      data-name="Path 63023"
                      d="M150.957,331.209h-23.7a.727.727,0,0,1-.686-.967l10.541-30.114a2.068,2.068,0,0,1,1.952-1.386h23.7a.728.728,0,0,1,.686.969l-10.541,30.114A2.068,2.068,0,0,1,150.957,331.209Z"
                      transform="translate(-126.53 -298.742)"
                      fill="#fff"
                      opacity="0.7"
                    />
                  </g>
                  <path
                    id="Path_63024"
                    data-name="Path 63024"
                    d="M140.963,310.149c-.246,1.154-1.043,2.089-1.782,2.089s-1.14-.935-.894-2.089,1.043-2.089,1.782-2.089S141.209,309,140.963,310.149Z"
                    transform="translate(-87.987 -293.915)"
                    fill="#fff"
                  />
                </g>
                <path
                  id="Path_63025"
                  data-name="Path 63025"
                  d="M92.084,279.887s5.787,28.483,9.69,33.208,20.905,17.43,20.905,17.43l10.1-2.121,7.243,6.045-4.735,3.738-5.606-2.109a52.715,52.715,0,0,1-9.257.8C115.2,336.88,94,324.4,89.792,317.4S79.7,284.042,79.7,284.042Z"
                  transform="translate(-75.343 -213.351)"
                  fill="#ffc3bd"
                />
                <g
                  id="Group_40690"
                  data-name="Group 40690"
                  transform="translate(25.054 47.204)"
                >
                  <path
                    id="Path_63026"
                    data-name="Path 63026"
                    d="M93.334,269.242l3.6-2.089,8.815,9.749s-4.846-1.979-6.209-1.18c-1.23.723-.37,3.845-1.8,3.871C94.574,279.648,93.334,269.242,93.334,269.242Z"
                    transform="translate(-93.334 -267.153)"
                    fill={primaryColor}
                  />
                  <path
                    id="Path_63027"
                    data-name="Path 63027"
                    d="M101.513,276.672l4.6-9.076,3.759,2.03s3.5,8.809.824,9.738c-1.626.565-2.248-3.555-3.862-4.152C105.539,274.734,101.513,276.672,101.513,276.672Z"
                    transform="translate(-89.097 -266.923)"
                    fill={primaryColor}
                  />
                </g>
                <path
                  id="Path_63030"
                  data-name="Path 63030"
                  d="M80.894,298.825s-6.7-20.272,2.127-27.128,12.961,23.372,12.961,23.372Z"
                  transform="translate(-75.985 -218.119)"
                  fill={primaryColor}
                />
                <path
                  id="Path_63033"
                  data-name="Path 63033"
                  d="M79.766,293.036l16.9-4.346-.676-3.475Z"
                  transform="translate(-75.309 -210.591)"
                  fill="#fdfdfd"
                  opacity="0.1"
                />
                <path
                  id="Path_63034"
                  data-name="Path 63034"
                  d="M96.5,259.94c-.067-.581-.138-1.149-.213-1.69l12.864,10.156a21.793,21.793,0,0,0-.95,4.367C100.432,272.842,97.49,264.252,96.5,259.94Z"
                  transform="translate(-66.749 -224.561)"
                  opacity="0.1"
                />
                <path
                  id="Path_63035"
                  data-name="Path 63035"
                  d="M98.829,251.7c-2.679,9.072-4.012,12.894-1.177,19.006,4.255,9.3,15.985,10.607,21.315,2.518,4.768-7.29,8.431-20.891.976-27.586A12.9,12.9,0,0,0,98.829,251.7Z"
                  transform="translate(-66.863 -232.835)"
                  fill="#ffc3bd"
                />
                <path
                  id="Path_63036"
                  data-name="Path 63036"
                  d="M104.663,254.84c-.255.724-.09,1.444.386,1.62s1.07-.275,1.325-1,.1-1.444-.376-1.62S104.927,254.117,104.663,254.84Z"
                  transform="translate(-62.473 -226.864)"
                  fill="#263238"
                />
                <path
                  id="Path_63037"
                  data-name="Path 63037"
                  d="M110.048,256.793c-.266.723-.091,1.454.376,1.62s1.07-.275,1.334-1,.09-1.445-.376-1.62S110.313,256.071,110.048,256.793Z"
                  transform="translate(-59.686 -225.852)"
                  fill="#263238"
                />
                <path
                  id="Path_63038"
                  data-name="Path 63038"
                  d="M108.436,256.576a20.723,20.723,0,0,0,2.086,5.218,3.3,3.3,0,0,1-2.781.162Z"
                  transform="translate(-60.816 -225.428)"
                  fill="#ed893e"
                />
                <path
                  id="Path_63039"
                  data-name="Path 63039"
                  d="M104.452,252.235a.459.459,0,0,0,.528.083c1.893-.911,4.272.381,4.29.393a.454.454,0,1,0,.443-.792c-.123-.02-2.814-1.535-5.126-.428a.458.458,0,0,0-.211.606A.362.362,0,0,0,104.452,252.235Z"
                  transform="translate(-62.582 -228.272)"
                  fill="#263238"
                />
                <path
                  id="Path_63040"
                  data-name="Path 63040"
                  d="M114.19,256.516a.472.472,0,0,0,.452.049.458.458,0,0,0,.231-.594,4.5,4.5,0,0,0-3.145-2.705.455.455,0,0,0-.156.9,3.614,3.614,0,0,1,2.464,2.171A.5.5,0,0,0,114.19,256.516Z"
                  transform="translate(-59.027 -227.146)"
                  fill="#263238"
                />
                <path
                  id="Path_63041"
                  data-name="Path 63041"
                  d="M99.06,260.218s3.4-.079,2.927-3.965c0,0,5.63-.159,5.869-4.282,0,0,4.917,4.361,6.661.952,0,0,6.027,5.392,6.819,1.825,0,0,6.265,7.771,5.948,3.013,0,0,7.057-.714.714-6.819,0,0,5.788-5.075-3.569-7.136,0,0,.818-6.018-5.77-3.368,0,0-1.526-6.541-7.235-2.734,0,0-3.085-4.6-6.458,1.586,0,0-4.978-2.851-6.563,3.572,0,0-9.008,1.1-5.293,7.012,0,0,2.78,19.876,5.293,19.876C100.111,269.747,99.06,260.218,99.06,260.218Z"
                  transform="translate(-68.861 -236.058)"
                  fill="#263238"
                />
                <path
                  id="Path_63042"
                  data-name="Path 63042"
                  d="M94.683,253.745a6.9,6.9,0,0,0,2.168,4.818c1.77,1.655,3.789.334,4.2-1.922.386-2.03-.062-5.333-2.288-6.127a3.107,3.107,0,0,0-4.084,3.23Z"
                  transform="translate(-67.588 -228.652)"
                  fill="#ffc3bd"
                />
                <path
                  id="Path_63043"
                  data-name="Path 63043"
                  d="M107.1,262.73a5.807,5.807,0,0,0,.978.2.194.194,0,0,0,.225-.159.07.07,0,0,0,0-.008.208.208,0,0,0-.182-.219,5.368,5.368,0,0,1-4.062-2.625.2.2,0,0,0-.358.173A5.525,5.525,0,0,0,107.1,262.73Z"
                  transform="translate(-62.917 -223.755)"
                  fill="#263238"
                />
              </g>
              <g
                id="Group_40693"
                data-name="Group 40693"
                transform="translate(0 30.106)"
              >
                <path
                  id="Path_63044"
                  data-name="Path 63044"
                  d="M64.618,260.961s-32.382,166.177,74.5,169.22c97.49,2.773,75.693-76.882,69.352-82.431s17.436,51.122-21.8,51.915c-47.3.955-55.878-43.989-71.73-44.385S75.12,375.887,72.743,337.843,82.847,235.2,64.618,260.961Z"
                  transform="translate(-60.008 -255.057)"
                  fill="#93999c"
                />
                <path
                  id="Path_63045"
                  data-name="Path 63045"
                  d="M64.618,260.961s-32.382,166.177,74.5,169.22c97.49,2.773,75.693-76.882,69.352-82.431s17.436,51.122-21.8,51.915c-47.3.955-55.878-43.989-71.73-44.385S75.12,375.887,72.743,337.843,82.847,235.2,64.618,260.961Z"
                  transform="translate(-60.008 -255.057)"
                  fill="#93999c"
                  opacity="0.5"
                />
              </g>
            </g>
          </g>
        </g>
        <g
          id="_29808814_7605496"
          data-name="29808814_7605496"
          transform="translate(471.905 883.554)"
        >
          <g id="Background_Complete" transform="translate(3.309 0)">
            <g
              id="Group_40718"
              data-name="Group 40718"
              transform="translate(0 70.354)"
            >
              <g
                id="Group_40706"
                data-name="Group 40706"
                transform="translate(96.75)"
              >
                <g id="Group_40705" data-name="Group 40705">
                  <g
                    id="Group_40695"
                    data-name="Group 40695"
                    transform="translate(20.402 8.975)"
                  >
                    <path
                      id="Path_63046"
                      data-name="Path 63046"
                      d="M396.966,286.244a11.377,11.377,0,0,0-.345,4.962c.519,3.478,3.136,6.232,3.7,9.656-.07.411-.156.826-.266,1.24a.049.049,0,0,1-.006.021.012.012,0,0,0,0,.01v0s0,0,0,.007a.05.05,0,0,0,.031.038c.024-.047.046-.1.066-.141.042-.087.08-.172.115-.259.054-.122.1-.244.148-.37.014.006.028-.055.029-.072,1.275-3.517.1-7.418-.49-10.987-.341-2.041-.2-4.1-.5-6.132-.073-.485-.069-1.406-.768-1.22C397.893,283.211,397.165,285.59,396.966,286.244Z"
                      transform="translate(-396.493 -282.975)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63047"
                      data-name="Path 63047"
                      d="M399.375,296.429c-.221,4.231,3.681,7.931,2.774,12.156-.029.12-.058.237-.09.355-.023.082-.046.163-.071.244v0l-.034.1a.05.05,0,0,1-.006.021.012.012,0,0,0,0,.01v0s0,0,0,.007a.051.051,0,0,0,.031.038.115.115,0,0,0,.016,0,.04.04,0,0,0,.035-.025c.049-.125.092-.252.13-.377a5.452,5.452,0,0,0,.215-.935s0,0,0,0a13.513,13.513,0,0,0-.084-5.663c-.484-2.4-1.1-4.729-1.534-7.156-.054-.3-.056-1.482-.537-1.325C399.609,294.083,399.4,295.941,399.375,296.429Zm.208-.629c.038-.238.343-1.828.739-1.662.236.1.265,1.3.3,1.472.141.655.28,1.306.421,1.961.3,1.376.609,2.748.906,4.123a18.131,18.131,0,0,1,.47,5.087C402.2,303.076,398.968,299.641,399.584,295.8Z"
                      transform="translate(-398.388 -290.162)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40696"
                    data-name="Group 40696"
                    transform="translate(19.86 43.76)"
                  >
                    <path
                      id="Path_63048"
                      data-name="Path 63048"
                      d="M394.9,394.27c0,.055.046.133.122.085,3.2-2.063,7.2-.383,10.52-2.226a17.02,17.02,0,0,0,3.563-2.846,13.6,13.6,0,0,0,2.169-2.581c.078-.129.484-.652.42-.913-.509-1.976-5.642,1.367-6.5,1.839a61.918,61.918,0,0,0-9.368,5.849c-.308.241-.614.493-.917.753C394.9,394.236,394.9,394.252,394.9,394.27Z"
                      transform="translate(-394.903 -385.17)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63049"
                      data-name="Path 63049"
                      d="M394.9,396.753c.118-.074.233-.148.349-.219a37.017,37.017,0,0,1,7.025-2.035,13.189,13.189,0,0,0,6.208-3.344c.313-.306,1.615-1.48,1.23-2.07-.345-.532-1.655.492-1.974.674-2.384,1.335-4.716,2.691-7.2,3.842-1.59.736-3.2,1.47-4.712,2.359q-.462.362-.917.753C394.9,396.718,394.9,396.735,394.9,396.753Zm1.5-.893c1.753-.98,3.594-1.8,5.419-2.664q1.881-.889,3.68-1.93c.657-.382,1.31-.772,1.971-1.148.333-.189.664-.375,1-.553.167-.093.717-.409.857-.154.377.688-3.3,4.18-7.869,5.084A28.476,28.476,0,0,0,396.4,395.86Z"
                      transform="translate(-394.903 -387.653)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40697"
                    data-name="Group 40697"
                    transform="translate(25.185 31.369)"
                  >
                    <path
                      id="Path_63050"
                      data-name="Path 63050"
                      d="M410.553,364.189a.028.028,0,0,0,0,.043.033.033,0,0,0,.049,0l.2-.194c.243-.239.477-.482.7-.728.041-.046.084-.089.125-.135a.08.08,0,0,0,.037-.014c2.56-2.618,6.439-3.418,8.623-6.453a14.7,14.7,0,0,0,2.055-4.5c.2-.687,1.186-2.781.322-3.325-.673-.422-1.725.5-2.164.886a19.823,19.823,0,0,0-3.353,4.539c-.953,1.537-1.819,3.118-2.725,4.679a30.1,30.1,0,0,1-2.864,4Q411.068,363.586,410.553,364.189Z"
                      transform="translate(-410.545 -348.767)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63051"
                      data-name="Path 63051"
                      d="M410.553,368.577a.028.028,0,0,0,0,.043c.21-.219.42-.439.632-.655-.129.154-.259.307-.384.459.243-.239.477-.482.7-.728.113-.13.225-.261.34-.39a41.04,41.04,0,0,1,4.718-3.912,8.684,8.684,0,0,0,2.127-2.11c1.073-1.538,2.737-5.158,2.416-5.706-.339-.583-.99.609-1.176.859-1.49,2.033-2.7,4.241-4.3,6.2-1.078,1.314-2.172,2.618-3.263,3.922-.275.266-.545.537-.805.816Q411.068,367.974,410.553,368.577Zm10.315-12.866c.282.118-.148,1.089-.258,1.346a40.67,40.67,0,0,1-1.8,3.665,8.9,8.9,0,0,1-2.871,2.889,30.21,30.21,0,0,0-2.769,2.2c1.084-1.227,2.155-2.465,3.157-3.752.83-1.07,1.552-2.212,2.286-3.35.366-.569.732-1.134,1.121-1.686.1-.151.88-1.416,1.134-1.31"
                      transform="translate(-410.545 -353.155)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40698"
                    data-name="Group 40698"
                    transform="translate(5.894 45.566)"
                  >
                    <path
                      id="Path_63052"
                      data-name="Path 63052"
                      d="M354.087,407.855a.025.025,0,0,0,.025.029.03.03,0,0,0,.035-.026c.016-.082.032-.161.048-.243.058-.3.108-.6.152-.891.007-.055.017-.108.024-.162a.077.077,0,0,0,.02-.029c.564-3.218,3.015-5.762,3.092-9.1a13.116,13.116,0,0,0-.759-4.351c-.2-.606-.529-2.644-1.439-2.609-.708.029-1.019,1.234-1.146,1.743a17.675,17.675,0,0,0-.179,5.031c.074,1.611.233,3.212.354,4.817a26.829,26.829,0,0,1-.088,4.391Q354.161,407.152,354.087,407.855Z"
                      transform="translate(-353.869 -390.476)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63053"
                      data-name="Path 63053"
                      d="M354.507,412.611a.025.025,0,0,0,.025.029c.044-.268.088-.535.135-.8-.018.178-.036.356-.052.531.058-.3.108-.6.152-.891.017-.153.034-.305.054-.458a36.552,36.552,0,0,1,1.5-5.257,7.747,7.747,0,0,0,.5-2.625c.014-1.673-.586-5.176-1.1-5.417-.544-.258-.421.947-.432,1.225-.071,2.247.151,4.482-.041,6.729-.131,1.51-.278,3.022-.424,4.532-.068.334-.13.67-.181,1.007Q354.582,411.908,354.507,412.611Zm.53-3.355c.179-1.449.343-2.9.431-4.353.071-1.206.027-2.411-.006-3.618-.018-.6-.033-1.2-.025-1.806,0-.164-.066-1.486.174-1.536.267-.056.44.876.488,1.121a36.158,36.158,0,0,1,.522,3.6,7.939,7.939,0,0,1-.657,3.573A27.035,27.035,0,0,0,355.038,409.256Z"
                      transform="translate(-354.29 -395.232)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40699"
                    data-name="Group 40699"
                    transform="translate(5.656 56.965)"
                  >
                    <path
                      id="Path_63054"
                      data-name="Path 63054"
                      d="M353.256,432.616a.491.491,0,0,0,.25-.087c3.277-1.255,6.863-1.31,10.157-2.564a9.556,9.556,0,0,0,3.828-2.521c.44-.5,1.963-2.217,1.626-3.014-1-2.4-12.064,5.154-15.7,7.868a.64.64,0,0,0-.166.113C353.137,432.516,353.154,432.608,353.256,432.616Z"
                      transform="translate(-353.172 -423.967)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63055"
                      data-name="Path 63055"
                      d="M353.256,435.455c.243-.133.487-.27.734-.4.8-.32,1.6-.624,2.417-.882,1.3-.409,2.635-.652,3.954-.984a12.579,12.579,0,0,0,5.527-2.953c.34-.312,1.35-1.145,1.13-1.73-.2-.532-1.028-.008-1.321.131-4.158,1.986-8.2,4.267-12.238,6.509-.073.035-.143.069-.211.107C353.137,435.354,353.154,435.447,353.256,435.455Zm1.93-1.057q2.37-1.289,4.743-2.56,1.862-.995,3.729-1.973c.616-.322,1.226-.653,1.849-.965.245-.122,1.192-.606,1.281-.264.085.313-.566.981-.684,1.1a13.19,13.19,0,0,1-6.835,3.484A30.09,30.09,0,0,0,355.186,434.4Z"
                      transform="translate(-353.172 -426.806)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40700"
                    data-name="Group 40700"
                    transform="translate(21.42 20.893)"
                  >
                    <path
                      id="Path_63056"
                      data-name="Path 63056"
                      d="M399.51,335.013a.141.141,0,0,0-.015.126.161.161,0,0,0,.142.1.188.188,0,0,0,.1-.009.069.069,0,0,0,.056-.019c1.548-1.513,3.911-2.923,5.5-4.376a16.831,16.831,0,0,0,3.07-3.872,22.791,22.791,0,0,0,2.265-5.037c.251-.838.972-2.821.291-3.645-1.4-1.7-4.228,4.477-4.634,5.168C404.012,327.3,401.742,331.143,399.51,335.013Z"
                      transform="translate(-399.486 -317.988)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63057"
                      data-name="Path 63057"
                      d="M399.511,340.118a.161.161,0,0,0,.142.1c.092-.129.182-.263.273-.392.605-.711,1.211-1.422,1.857-2.1,1.05-1.106,2.251-2.062,3.265-3.2,1.765-1.985,5.078-8.307,4.126-8.937-.5-.329-1.11.973-1.291,1.28-.712,1.218-1.266,2.517-2,3.728-.76,1.272-1.6,2.5-2.429,3.722-1.285,1.886-2.577,3.765-3.841,5.667C399.581,340.03,399.548,340.073,399.511,340.118Zm1.27-1.532c1.143-1.667,2.27-3.343,3.4-5.018.78-1.157,1.552-2.325,2.247-3.537.387-.679.736-1.378,1.084-2.077.171-.339.341-.682.535-1.011.167-.283.785-1.464,1.064-1.032.268.417-.559,2.285-.755,2.718-.323.7-.654,1.4-1.011,2.089a18.129,18.129,0,0,1-2.542,3.794c-1.024,1.131-2.22,2.09-3.253,3.212C401.294,338.008,401.034,338.294,400.781,338.587Z"
                      transform="translate(-399.503 -322.967)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40701"
                    data-name="Group 40701"
                    transform="translate(0 35.133)"
                  >
                    <path
                      id="Path_63058"
                      data-name="Path 63058"
                      d="M339.441,365.689c2.847,3.094,7.441,3.953,9.117,9.375a.023.023,0,0,0,.041.008.015.015,0,0,0,.009-.02c-.1-.547-.226-1.091-.373-1.633a23.691,23.691,0,0,0-3.936-8.129,17.888,17.888,0,0,0-3.845-3.766c-.751-.531-2.374-1.886-3.311-1.677C335.12,360.3,338.922,365.127,339.441,365.689Z"
                      transform="translate(-336.555 -359.825)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63059"
                      data-name="Path 63059"
                      d="M344.465,367.589c1.147,2.25,3.422,3.707,5.162,5.458a20.476,20.476,0,0,1,3.149,3.984c.236.609.46,1.222.676,1.846a.015.015,0,0,0,.009-.02c-.1-.547-.226-1.091-.373-1.633-.018-.028-.032-.059-.05-.087a25.1,25.1,0,0,0-2.364-4.731,26,26,0,0,0-4.695-5.567c-.313-.283-1.348-1.508-1.885-1.2C343.581,365.943,344.3,367.276,344.465,367.589Zm-.192-1.746c.392-.147,2.219,1.667,2.934,2.408a25.962,25.962,0,0,1,3.966,5.314,24.254,24.254,0,0,1,1.25,2.584,20.745,20.745,0,0,0-2.06-2.577c-1.569-1.682-3.533-3.029-4.956-4.835a7.241,7.241,0,0,1-.944-1.536C344.368,366.981,343.916,365.977,344.273,365.843Z"
                      transform="translate(-341.409 -363.631)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40702"
                    data-name="Group 40702"
                    transform="translate(6.267 20.818)"
                  >
                    <path
                      id="Path_63060"
                      data-name="Path 63060"
                      d="M355.118,321.065a19.291,19.291,0,0,0-.031,4.554,19,19,0,0,0,2.976,8.206c.028.043.055.089.087.134.025.144.052.289.088.431.006.033.013.063.021.1l.008.02h0a.037.037,0,0,0,.064-.029c0-.177,0-.356.006-.535.058-3.664.735-7.253.244-10.923-.11-.8-.632-6.047-2.464-5.15C355.267,318.289,355.211,320.3,355.118,321.065Z"
                      transform="translate(-354.967 -317.77)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63061"
                      data-name="Path 63061"
                      d="M357.524,326.18a27.24,27.24,0,0,0,.93,6.884,52.213,52.213,0,0,0,1.284,5.139c.041.137.088.277.133.413.012.05.027.1.042.151a.71.71,0,0,0,.029.118h0a.037.037,0,0,0,.064-.029c0-.177,0-.356.006-.535-.035-.135-.075-.268-.11-.4a42.718,42.718,0,0,1-.226-6.019c.009-1.092-.008-2.178-.1-3.266a14.609,14.609,0,0,0-.466-3.175c-.142-.438-.437-1.3-1.053-.983C357.539,324.747,357.553,325.7,357.524,326.18Zm1.346-.762a16.152,16.152,0,0,1,.529,3.823c.084,1.188.07,2.383.058,3.572a37.81,37.81,0,0,0,.09,3.808c-.434-1.588-.852-3.18-1.161-4.812-.243-1.275-.455-2.558-.6-3.846a9.664,9.664,0,0,1-.065-2,5.358,5.358,0,0,1,.1-.706C357.974,324.519,358.7,324.881,358.871,325.418Z"
                      transform="translate(-356.643 -322.148)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40703"
                    data-name="Group 40703"
                    transform="translate(28.882)"
                  >
                    <path
                      id="Path_63062"
                      data-name="Path 63062"
                      d="M421.447,271.2c-.013.059-.023.116-.036.175a.109.109,0,0,0,.216.037c.024-.105.05-.213.074-.318v0c.019-.087.04-.17.059-.257.079-.142.163-.281.256-.417.971-1.471,2.655-2.714,3.8-3.969a23.155,23.155,0,0,0,2.822-3.667,11.387,11.387,0,0,0,1.637-4.374c.052-.421.251-1.482-.274-1.747-.664-.335-1.678.938-2.035,1.271a19.025,19.025,0,0,0-3.17,3.935A27.774,27.774,0,0,0,421.447,271.2Z"
                      transform="translate(-421.409 -256.607)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63063"
                      data-name="Path 63063"
                      d="M421.744,273.845a6.569,6.569,0,0,0-.3.729c-.013.059-.023.116-.036.175a.106.106,0,0,0,.136.121c.013-.042.025-.084.04-.125.038-.092.075-.185.113-.277v0c.1-.229.2-.451.315-.673a15.1,15.1,0,0,1,1.424-2.266c.933-1.245,1.912-2.456,2.8-3.736.444-.641,3.86-5.583,2.516-6.055-.252-.092-.5.248-.632.388a10.374,10.374,0,0,0-1.226,1.655c-.856,1.339-1.663,2.713-2.425,4.109A43.829,43.829,0,0,0,421.744,273.845Zm2.443-5.1c.652-1.237,1.344-2.449,2.065-3.644.352-.581.7-1.169,1.087-1.732.19-.279,1.15-1.532,1.413-1.368.385.241-.529,2.193-.807,2.719-.319.6-.665,1.183-1.027,1.756-.73,1.154-1.537,2.258-2.365,3.343-.731.962-1.6,1.981-2.289,3.087A44.347,44.347,0,0,1,424.186,268.742Z"
                      transform="translate(-421.409 -259.98)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40704"
                    data-name="Group 40704"
                    transform="translate(15.388 14.919)"
                  >
                    <path
                      id="Path_63064"
                      data-name="Path 63064"
                      d="M383.559,317.307c.018.057.039.112.057.169a.109.109,0,0,0,.2-.076l-.1-.313v0c-.027-.085-.05-.167-.077-.252,0-.162,0-.325.012-.488.1-1.759.935-3.68,1.293-5.339a23.12,23.12,0,0,0,.6-4.588,11.382,11.382,0,0,0-.779-4.6c-.166-.39-.527-1.408-1.114-1.374-.742.044-.981,1.654-1.123,2.12a19.017,19.017,0,0,0-.768,4.995A27.794,27.794,0,0,0,383.559,317.307Z"
                      transform="translate(-381.764 -300.438)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63065"
                      data-name="Path 63065"
                      d="M385.448,320.575a6.625,6.625,0,0,0,.11.78c.018.057.039.112.057.169a.106.106,0,0,0,.178.036c-.01-.042-.021-.085-.028-.129-.013-.1-.028-.2-.041-.3v0c-.03-.247-.051-.492-.065-.74a15.062,15.062,0,0,1,.095-2.674c.182-1.545.421-3.083.546-4.636.062-.778.537-6.766-.862-6.5-.264.047-.3.464-.352.653a10.377,10.377,0,0,0-.23,2.047c-.068,1.587-.077,3.182-.036,4.771A43.925,43.925,0,0,0,385.448,320.575Zm-.448-5.64c-.057-1.4-.067-2.793-.042-4.189.013-.679.022-1.364.072-2.044.024-.337.226-1.9.536-1.892.454.015.643,2.162.666,2.757.025.679.019,1.357-.007,2.034-.053,1.364-.2,2.724-.369,4.078-.15,1.2-.394,2.519-.431,3.819A44.08,44.08,0,0,1,385,314.935Z"
                      transform="translate(-383.762 -304.485)"
                      fill="#fff"
                    />
                  </g>
                  <path
                    id="Path_63066"
                    data-name="Path 63066"
                    d="M348.106,312.36a85.258,85.258,0,0,0,1.931,9.406,32.971,32.971,0,0,1,1.4,7.325,18.735,18.735,0,0,1-2.265,9.153q1.312-1.465,2.6-2.974a35.2,35.2,0,0,0,4.716-6.548c.122-.237.233-.478.345-.72a.078.078,0,0,1-.011-.058,32.4,32.4,0,0,0,.625-9.657,26.806,26.806,0,0,0-2.1-4.833,21.527,21.527,0,0,1-2.177-4.9c-.027-.1.115-.161.154-.059.891,2.337,2.723,4.611,3.8,7.034-.062-.4-.127-.8-.2-1.2-.7-3.835-2.029-7.689-.626-11.523.047-.128.23-.041.191.085-1.322,4.27.758,8.975,1.374,13.218a25.893,25.893,0,0,1-.152,9.7,51.163,51.163,0,0,0,1.4-5.306c2.413-10.763,5.205-21.466,10.438-31.248.051-.1.2-.029.155.069-5.356,10.615-7.48,22.153-10.27,33.591-.032.13-.066.259-.1.389a21.615,21.615,0,0,1,3.364-4.067c.061-.06.16.016.105.086-1.534,1.966-2.706,4.117-4.088,6.17a22.367,22.367,0,0,1-2,4.606,36.433,36.433,0,0,1-3.562,4.873c2.185-1.833,4.39-3.641,6.445-5.637a97.713,97.713,0,0,0,8.739-9.613c.039-.049.111.011.075.062a81.686,81.686,0,0,1-8.7,10.375,54.636,54.636,0,0,1-8.9,7.538,54.136,54.136,0,0,1-10.4,9.833.173.173,0,0,1-.2-.28c.725-.644,1.432-1.3,2.132-1.96.681-1.522,1.625-2.917,2.231-4.493a24.826,24.826,0,0,0,1.448-5.726c.019-.145.23-.108.221.033a20.83,20.83,0,0,1-2.2,8.537q1.5-1.481,2.936-3.011c2.564-3.915,4.234-8.568,3.673-13.252a62.077,62.077,0,0,0-1.544-7.083,52.254,52.254,0,0,1-1.18-7.915A.09.09,0,0,1,348.106,312.36Z"
                    transform="translate(-338.92 -278.111)"
                    fill="#ebebeb"
                  />
                </g>
              </g>
              <g
                id="Group_40717"
                data-name="Group 40717"
                transform="translate(0 6.478)"
              >
                <g id="Group_40716" data-name="Group 40716">
                  <g
                    id="Group_40707"
                    data-name="Group 40707"
                    transform="translate(30.821 11.002)"
                  >
                    <path
                      id="Path_63067"
                      data-name="Path 63067"
                      d="M146.128,309.554a13.512,13.512,0,0,1,.372,4.992,39.472,39.472,0,0,1-.634,5.422c-.3,1.669-.686,3.322-1.1,4.964l-.014.046c-.026.109-.054.217-.082.324-.015.133-.033.268-.056.4a.082.082,0,0,1-.071.069.067.067,0,0,1-.084-.075c.007-.073.016-.148.021-.22.267-3.083-1.511-5.9-1.618-8.951a22.711,22.711,0,0,1,.656-4.985,15.945,15.945,0,0,1,.568-2.929c.093-.226.115-.469.368-.59C145.237,307.657,145.936,309.021,146.128,309.554Z"
                      transform="translate(-142.859 -307.963)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63068"
                      data-name="Path 63068"
                      d="M147.148,315.827c-.485-.4-.77.707-.864,1.009a14.681,14.681,0,0,0-.626,6.566,28.99,28.99,0,0,1,.644,6.978l-.068.229c-.005.071-.014.147-.021.22a.067.067,0,0,0,.084.075c.008-.048.016-.092.021-.138.067-.218.129-.438.187-.658l.014-.046a44.135,44.135,0,0,0,.811-4.8,31.054,31.054,0,0,0,.361-6.8,15.885,15.885,0,0,0-.205-1.635C147.437,316.554,147.386,316.021,147.148,315.827Zm.272,1.373c.088.573.145,1.148.176,1.729a31.689,31.689,0,0,1-.348,5.972,43.9,43.9,0,0,1-.849,5.118,18.062,18.062,0,0,0-.17-4.008c-.139-1-.349-1.986-.5-2.985a11.216,11.216,0,0,1,.12-3.364,14.244,14.244,0,0,1,.675-3.115c.078-.2.3-.638.475-.607C147.305,315.993,147.388,316.974,147.421,317.2Z"
                      transform="translate(-144.609 -313.094)"
                      fill="#fff"
                    />
                  </g>
                  <path
                    id="Path_63069"
                    data-name="Path 63069"
                    d="M111.782,381.793s0-.01-.006-.006"
                    transform="translate(-91.535 -345.656)"
                    fill="#ebebeb"
                  />
                  <g
                    id="Group_40708"
                    data-name="Group 40708"
                    transform="translate(15.202 47.142)"
                  >
                    <path
                      id="Path_63070"
                      data-name="Path 63070"
                      d="M114.359,424.428a.073.073,0,0,1,.035.09v0a.084.084,0,0,1-.063.061.105.105,0,0,1-.064-.008c-1.886-.954-3.688-2.471-5.873-2.581-1.71-.09-3.179.122-4.8-.578a12.906,12.906,0,0,1-4.344-3.116,13.3,13.3,0,0,1-1.481-1.957c-.207-.334-.882-1.166-.786-1.6.44-2,6.389,1.562,7.18,2.043a53.9,53.9,0,0,1,9.979,7.413.032.032,0,0,1,.008.033.049.049,0,0,1-.021.034C114.2,424.321,114.282,424.372,114.359,424.428Z"
                      transform="translate(-96.972 -414.139)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63071"
                      data-name="Path 63071"
                      d="M118.775,427.44c-.077-.055-.154-.107-.231-.159a.048.048,0,0,0,.021-.034c-1.934-1.467-3.985-2.8-6.045-4.08a60.044,60.044,0,0,0-6.857-3.855c-.325-.148-1.677-.957-1.961-.432-.273.5,1.123,1.725,1.421,1.993a15.78,15.78,0,0,0,6.293,2.954,16.6,16.6,0,0,1,4.159,1.629c1.087.67,2.093,1.462,3.171,2.139a.084.084,0,0,0,.063-.061c-.552-.351-1.086-.738-1.617-1.119.54.37,1.08.743,1.618,1.115A.073.073,0,0,0,118.775,427.44Zm-4.874-2.978c-2.165-.845-4.489-1.216-6.575-2.282a9.236,9.236,0,0,1-2.693-2c-.146-.159-.851-.867-.691-1.149.107-.188.67-.016.751.016a16.75,16.75,0,0,1,1.8.8c2.039,1.04,4.018,2.216,5.961,3.422,1.079.67,2.135,1.367,3.184,2.08A10.367,10.367,0,0,0,113.9,424.461Z"
                      transform="translate(-101.388 -417.151)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40709"
                    data-name="Group 40709"
                    transform="translate(18.177 12.871)"
                  >
                    <path
                      id="Path_63072"
                      data-name="Path 63072"
                      d="M111.521,316.512a13.814,13.814,0,0,1-.623,5.438c-1.143,4.025-3.351,7.765-4.051,11.917-.028.163-.053.327-.075.489.037.215.009.163-.06-.09,0,0,0,0,0,0a29.321,29.321,0,0,1-.873-9.464,30.582,30.582,0,0,1,1.806-6.293c.432-1.172.851-2.349,1.29-3.517.142-.375.34-1.446.907-1.528C110.937,313.3,111.427,315.8,111.521,316.512Z"
                      transform="translate(-105.713 -313.453)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63073"
                      data-name="Path 63073"
                      d="M110.938,323.414a.369.369,0,0,0-.488.128,1.866,1.866,0,0,0-.238.712c-.111.429-.222.854-.332,1.281a58.421,58.421,0,0,0-2.072,9,25.3,25.3,0,0,0,.217,6.07q0,.1,0,.2s0,0,0,0c.068.253.1.3.06.089.022-.162.047-.325.075-.488,0-.226.008-.453.021-.681a18.562,18.562,0,0,1,1.029-4.574,46.231,46.231,0,0,0,2.078-8.686,8.975,8.975,0,0,0,.068-2C111.33,324.169,111.256,323.575,110.938,323.414Zm.266.952a3.035,3.035,0,0,1,.043.439,8.058,8.058,0,0,1-.023.942,22.19,22.19,0,0,1-.3,2.254,63.136,63.136,0,0,1-2.062,7.806,16.614,16.614,0,0,0-.809,3.911,33.168,33.168,0,0,1-.168-3.359,34.109,34.109,0,0,1,1.52-8.352c.176-.682.353-1.367.529-2.049.086-.343.174-.684.262-1.024l.13-.513c.086-.343.036-.486.418-.592C111.212,323.7,111.139,323.969,111.2,324.367Z"
                      transform="translate(-107.034 -319.993)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40710"
                    data-name="Group 40710"
                    transform="translate(24.36 30.196)"
                  >
                    <path
                      id="Path_63074"
                      data-name="Path 63074"
                      d="M126.367,366.916a22.479,22.479,0,0,1,1.1,4.131c.469,2.824.035,6.09.777,8.9.066.183.125.372.177.56.021.071.039.141.056.211a.037.037,0,0,1-.069.024c-.058-.119-.117-.238-.179-.358,0,0,0,0,0-.006-.03-.063-.064-.126-.094-.188-1.4-2.739-3.2-5.244-3.793-8.321-.368-1.893-.954-7.111.3-7.508C125.192,364.186,126.062,366.1,126.367,366.916Z"
                      transform="translate(-123.877 -364.352)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63075"
                      data-name="Path 63075"
                      d="M127.231,372.641c-.3.141-.288.725-.306.969a11.931,11.931,0,0,0,.069,1.946,19.572,19.572,0,0,0,.7,3.547,38.381,38.381,0,0,0,2.434,6.538c.03.063.064.126.094.188,0,0,0,0,0,.006.063.119.121.239.179.358a.037.037,0,0,0,.069-.024c-.017-.07-.035-.141-.056-.211a31.95,31.95,0,0,1-1.626-7.519C128.723,377.863,128.257,372.155,127.231,372.641Zm.933,2.316c.09.538.165,1.078.236,1.621.169,1.262.312,2.529.5,3.79a28.99,28.99,0,0,0,.858,4.077,48.778,48.778,0,0,1-1.713-4.654,26.161,26.161,0,0,1-.773-3.177,13.354,13.354,0,0,1-.181-1.766c-.013-.283-.132-1.918.207-2.058C127.713,372.617,128.126,374.725,128.164,374.957Z"
                      transform="translate(-125.875 -369.8)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40711"
                    data-name="Group 40711"
                    transform="translate(29.654 26.863)"
                  >
                    <path
                      id="Path_63076"
                      data-name="Path 63076"
                      d="M148.564,354.883c.69.848.364,2.54-.009,3.433a8.081,8.081,0,0,1-2.582,3.125c-1.555,1.231-3.291,2.179-4.6,3.7s-.881,1.051-1.792,2.979c-.017.038-.054.039-.083.006a.372.372,0,0,1-.056-.308c0-.015.005-.035.008-.052a19.879,19.879,0,0,1,4.62-8.138c1.223-1.4,1.961-3.179,3.235-4.53C147.775,354.594,148.09,354.3,148.564,354.883Z"
                      transform="translate(-139.432 -354.56)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63077"
                      data-name="Path 63077"
                      d="M147.832,360.342c-.467-.221-1.053.726-1.292,1.068a19.839,19.839,0,0,1-2.227,2.833,24.089,24.089,0,0,0-2.175,2.324,15.9,15.9,0,0,0-2.361,4.244,8.393,8.393,0,0,0-.338.8.372.372,0,0,0,.056.308c.011-.036.022-.069.034-.105a10.9,10.9,0,0,1,3.841-4.954,13.41,13.41,0,0,0,4.4-4.9C147.937,361.586,148.263,360.548,147.832,360.342Zm-.075,1.346a8.973,8.973,0,0,1-.528,1.035,11.06,11.06,0,0,1-1.255,1.687,19.512,19.512,0,0,1-2.8,2.431,11.881,11.881,0,0,0-2.929,3.116,16.249,16.249,0,0,1,2.2-3.6c.8-.98,1.779-1.775,2.6-2.727.379-.441.715-.913,1.05-1.384.179-.258.359-.515.538-.769.159-.227.667-1.036,1.007-.97C148.087,360.587,147.819,361.546,147.757,361.688Z"
                      transform="translate(-139.43 -358.352)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40712"
                    data-name="Group 40712"
                    transform="translate(1.146 12.478)"
                  >
                    <path
                      id="Path_63078"
                      data-name="Path 63078"
                      d="M64.279,319c2.8,3.165,5.408,6.492,7.888,9.913a.108.108,0,0,1,0,.132.044.044,0,0,1-.013.023.707.707,0,0,1,.046.066.047.047,0,0,1-.014.065l-.016.007a.011.011,0,0,1-.006,0,.061.061,0,0,1-.05-.014,23.3,23.3,0,0,0-5.59-4.449,29.053,29.053,0,0,1-5.742-3.366c-1.492-1.26-5.722-7.474-5.034-8.957C56.214,311.427,62.047,316.489,64.279,319Z"
                      transform="translate(-55.675 -312.298)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63079"
                      data-name="Path 63079"
                      d="M66.211,322.89c-.365-.352-1.438-1.744-2.122-1.461s.406,1.688.609,1.985A20.384,20.384,0,0,0,67.19,326.5a20.253,20.253,0,0,0,3.161,2.253,39.5,39.5,0,0,1,7.218,6.461.011.011,0,0,0,.006,0l.016-.007a.046.046,0,0,0,.014-.065.7.7,0,0,0-.046-.066.044.044,0,0,0,.013-.023A115.582,115.582,0,0,0,66.211,322.89Zm11.122,12.02a45.666,45.666,0,0,0-4.769-4.639c-1.976-1.655-4.363-2.72-6.072-4.687a15.34,15.34,0,0,1-2.241-3.108c-.075-.151-.353-.656-.165-.855.166-.179.649.043,1.253.6.5.459.974.948,1.459,1.423,1.911,1.867,3.812,3.742,5.648,5.685Q75,332.024,77.333,334.91Z"
                      transform="translate(-61.078 -318.296)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40713"
                    data-name="Group 40713"
                    transform="translate(4.691 38.287)"
                  >
                    <path
                      id="Path_63080"
                      data-name="Path 63080"
                      d="M82.81,392.216a.066.066,0,0,1-.01.046.075.075,0,0,1-.093.048c-.088-.031-.178-.056-.268-.085a.029.029,0,0,1-.023.007,13.946,13.946,0,0,0-5.56.574,8.858,8.858,0,0,1-4.337-.007,14.774,14.774,0,0,1-4.373-1.976c-.55-.353-2.312-1.142-2.025-2.108.472-1.589,5.815.48,6.74.779a41.848,41.848,0,0,0,5,1.34,20.609,20.609,0,0,1,4.91,1.326A.054.054,0,0,1,82.81,392.216Z"
                      transform="translate(-66.091 -388.122)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63081"
                      data-name="Path 63081"
                      d="M87.033,394.359a0,0,0,0,1,0,0c-.968-.221-1.933-.483-2.91-.653-1.094-.192-2.212-.168-3.309-.356-2.055-.357-4.009-1.1-6.041-1.555-.265-.058-.787-.161-.647.29.058.2.341.355.489.46a9.479,9.479,0,0,0,1.432.839,12.024,12.024,0,0,0,5.547,1.313c2.192-.1,4.324-.513,6.49-.047a.066.066,0,0,0,.01-.046A6.721,6.721,0,0,0,87.033,394.359Zm-4.748.133a12.074,12.074,0,0,1-6.9-1.624,9.965,9.965,0,0,1-.884-.59c-.17-.142-.414-.444.231-.363a3.841,3.841,0,0,1,.449.108c.525.131,1.045.277,1.568.425,1.111.317,2.22.651,3.352.888a20.728,20.728,0,0,0,3.044.362,24.812,24.812,0,0,1,3.668.629A22.729,22.729,0,0,0,82.286,394.491Z"
                      transform="translate(-71.376 -390.508)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40714"
                    data-name="Group 40714"
                    transform="translate(0 24.973)"
                  >
                    <path
                      id="Path_63082"
                      data-name="Path 63082"
                      d="M67.943,362.07a.169.169,0,0,1,0,.093.129.129,0,0,1-.017.046.156.156,0,0,1-.036.05.023.023,0,0,1-.014.013.137.137,0,0,1-.142.014,6.161,6.161,0,0,1-.854-.387c-3.32-1.267-6.722-2.6-9.423-4.948a21.822,21.822,0,0,1-3.611-4.094c-.509-.736-1.91-2.281-1.447-3.313.449-1,1.371-.367,1.992.054a47.059,47.059,0,0,1,4.65,3.511,25.831,25.831,0,0,1,3.888,4.227c1.358,1.854,2.661,3.776,4.9,4.618A.162.162,0,0,1,67.943,362.07Z"
                      transform="translate(-52.309 -349.007)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63083"
                      data-name="Path 63083"
                      d="M66.112,362.081a56.3,56.3,0,0,0-6.069-5.5c-.275-.221-1.075-.789-1.2-.151-.145.751.965,1.636,1.388,2.083a42.759,42.759,0,0,0,5.2,4.715,23.966,23.966,0,0,0,6.8,3.683.132.132,0,0,0,.017-.046A30.564,30.564,0,0,1,61.7,359.785c-.732-.719-1.474-1.445-2.145-2.222-.108-.125-.723-.963-.483-1.192.21-.2,1.076.485,1.179.573q.727.6,1.449,1.208a66.286,66.286,0,0,1,5.114,4.887,16.265,16.265,0,0,0,5.434,3.829.169.169,0,0,0,0-.093A18.955,18.955,0,0,1,66.112,362.081Z"
                      transform="translate(-56.61 -353.712)"
                      fill="#fff"
                    />
                  </g>
                  <g
                    id="Group_40715"
                    data-name="Group 40715"
                    transform="translate(5.197)"
                  >
                    <path
                      id="Path_63084"
                      data-name="Path 63084"
                      d="M71.911,279.141a16.133,16.133,0,0,1,2.623,4.976c.81,2.8.762,5.737,1.165,8.606a.141.141,0,0,0,0,.033,19.35,19.35,0,0,0,.455,2.316q.062.244.136.488a.1.1,0,0,1-.016.1.132.132,0,0,1-.065.034.12.12,0,0,1-.069,0l0,0a.127.127,0,0,1-.078-.077c-.081-.23-.153-.461-.222-.695a.054.054,0,0,1-.035-.031c-1.714-3.581-3.659-7.2-5.6-10.743a28.623,28.623,0,0,1-2.213-4.9c-.329-1.009-.729-2.566.008-3.5a.224.224,0,0,1,.2-.106C69.812,275.917,71.025,277.93,71.911,279.141Z"
                      transform="translate(-67.579 -275.639)"
                      fill="#ebebeb"
                    />
                    <path
                      id="Path_63085"
                      data-name="Path 63085"
                      d="M73.894,286.515c-.775-.25-.617.667-.492,1.131a32.185,32.185,0,0,0,1.368,3.617q.815,2,1.689,3.983c1.1,2.488,2.637,4.966,3.451,7.576,0,0,0,.008,0,.012l0,0a.121.121,0,0,0,.069,0,.132.132,0,0,0,.065-.034c-.04-.2-.08-.391-.12-.588-.155-.771-.3-1.545-.455-2.316a.194.194,0,0,1,0-.033c-.734-3.716-1.542-7.4-3.493-10.806C75.521,288.27,74.847,286.82,73.894,286.515Zm2.319,3.249a26.925,26.925,0,0,1,2.465,6.806c.425,1.879.714,3.783,1.1,5.668-.539-1.514-1.33-2.953-2.011-4.419q-1.6-3.452-3.027-6.981-.344-.848-.673-1.7a6.359,6.359,0,0,1-.615-1.842c0-1.069.888-.343,1.178-.027a6.382,6.382,0,0,1,.652.913Q75.782,288.954,76.212,289.764Z"
                      transform="translate(-71.351 -282.785)"
                      fill="#fff"
                    />
                  </g>
                  <path
                    id="Path_63086"
                    data-name="Path 63086"
                    d="M107.136,326.614a77.886,77.886,0,0,1-2.119,10.345,68.522,68.522,0,0,0-2.2,9.449c-.562,4.271-.176,8.952,2,12.666a50.374,50.374,0,0,1-8.575-14.335c-3.509-8.81-6.686-17.866-10.946-26.354-.071-.141-.266-.031-.213.109,1.746,4.634,3.8,9.154,5.583,13.775,1.774,4.588,3.42,9.235,5.277,13.79q.3.739.625,1.462a24.83,24.83,0,0,0-10.621-7.293c-.05-.018-.071.057-.024.078a27.622,27.622,0,0,1,7.546,5.016,41.577,41.577,0,0,1,5,5.982,42.407,42.407,0,0,0,14.806,15.452.06.06,0,0,0,.063-.1,42.4,42.4,0,0,1-6.848-5.749c-3.5-4.633-3.664-10.818-2.621-16.439.547-2.948,1.327-5.841,2.026-8.755a35.917,35.917,0,0,0,1.407-9.09A.083.083,0,0,0,107.136,326.614Z"
                    transform="translate(-73.922 -303.792)"
                    fill="#ebebeb"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_40723"
              data-name="Group 40723"
              transform="translate(24.367 7.996)"
            >
              <g
                id="Group_40720"
                data-name="Group 40720"
                transform="translate(0)"
              >
                <g id="Group_40719" data-name="Group 40719">
                  <path
                    id="Path_63087"
                    data-name="Path 63087"
                    d="M123.971,74.741,123.9,183.677l82.624-1.339L206.6,73.4Z"
                    transform="translate(-123.9 -73.401)"
                    fill="#dbdbdb"
                  />
                  <path
                    id="Path_63088"
                    data-name="Path 63088"
                    d="M372.832,287.584l-.022,33.588-6.167,1.806.023-36.364Z"
                    transform="translate(-284.019 -214.041)"
                    fill="#dbdbdb"
                  />
                </g>
              </g>
              <g
                id="Group_40721"
                data-name="Group 40721"
                transform="translate(0 1.34)"
              >
                <path
                  id="Path_63089"
                  data-name="Path 63089"
                  d="M123.97,77.337,123.9,186.705l79.622,3.562L203.592,80.9Z"
                  transform="translate(-123.899 -77.337)"
                  fill="#ebebeb"
                />
              </g>
              <g
                id="Group_40722"
                data-name="Group 40722"
                transform="translate(44.646 9.038)"
              >
                <path
                  id="Path_63090"
                  data-name="Path 63090"
                  d="M260.959,101.5l-1.944-.068v6.529a.636.636,0,0,1-.673.649.7.7,0,0,1-.673-.7v-6.529l-1.932-.068a.711.711,0,0,1-.673-.709.636.636,0,0,1,.673-.649l5.221.184a.7.7,0,0,1,.673.7A.661.661,0,0,1,260.959,101.5Z"
                  transform="translate(-255.065 -99.955)"
                  fill="#fff"
                />
                <path
                  id="Path_63091"
                  data-name="Path 63091"
                  d="M280.3,108.706v-7.214a.636.636,0,0,1,.673-.649H281l3.961.14a.708.708,0,0,1,.673.7.661.661,0,0,1-.673.661l-3.313-.116v2.238l2.849.1a.717.717,0,0,1,.673.7.653.653,0,0,1-.673.661l-2.849-.1v2.25l3.313.116a.719.719,0,0,1,.673.708.658.658,0,0,1-.673.649L281,109.4c-.024,0-.024-.013-.024-.013l-.012.012A.7.7,0,0,1,280.3,108.706Z"
                  transform="translate(-271.707 -100.54)"
                  fill="#fff"
                />
                <path
                  id="Path_63092"
                  data-name="Path 63092"
                  d="M300.559,107.666a.633.633,0,0,1,.892-.054,4.142,4.142,0,0,0,2.336,1.024,2.566,2.566,0,0,0,1.528-.4,1.055,1.055,0,0,0,.526-.862.72.72,0,0,0-.11-.4,1.214,1.214,0,0,0-.367-.38,5.073,5.073,0,0,0-1.675-.633h-.025a6.848,6.848,0,0,1-1.578-.532,2.766,2.766,0,0,1-1.137-.994,1.929,1.929,0,0,1-.281-1.013,2.166,2.166,0,0,1,.978-1.751,3.518,3.518,0,0,1,2.115-.574,4.962,4.962,0,0,1,2.666,1.072.64.64,0,0,1,.171.874.608.608,0,0,1-.868.153,3.676,3.676,0,0,0-1.969-.852,2.269,2.269,0,0,0-1.369.368.931.931,0,0,0-.465.754.607.607,0,0,0,.086.346,1.248,1.248,0,0,0,.33.329,4.371,4.371,0,0,0,1.529.592h.024a7.4,7.4,0,0,1,1.687.573,3.007,3.007,0,0,1,1.223,1.058,2.041,2.041,0,0,1,.293,1.05,2.27,2.27,0,0,1-1.051,1.858,3.72,3.72,0,0,1-2.262.617,5.465,5.465,0,0,1-3.13-1.333A.656.656,0,0,1,300.559,107.666Z"
                  transform="translate(-284.986 -100.71)"
                  fill="#fff"
                />
                <path
                  id="Path_63093"
                  data-name="Path 63093"
                  d="M329,103.89l-1.944-.068v6.529a.636.636,0,0,1-.673.649.7.7,0,0,1-.673-.7v-6.529l-1.932-.068A.711.711,0,0,1,323.1,103a.636.636,0,0,1,.673-.649l5.221.184a.7.7,0,0,1,.672.7A.661.661,0,0,1,329,103.89Z"
                  transform="translate(-299.944 -101.534)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Group_40729"
              data-name="Group 40729"
              transform="translate(18.627 0)"
            >
              <g
                id="Group_40727"
                data-name="Group 40727"
                transform="translate(0)"
              >
                <g
                  id="Group_40725"
                  data-name="Group 40725"
                  transform="translate(2.708 0.102)"
                >
                  <g
                    id="Group_40724"
                    data-name="Group 40724"
                    transform="translate(0 0)"
                  >
                    <rect
                      id="Rectangle_19431"
                      data-name="Rectangle 19431"
                      width="132.439"
                      height="99.708"
                      transform="translate(0 132.346) rotate(-87.839)"
                      fill="#ebebeb"
                    />
                  </g>
                </g>
                <g
                  id="Group_40726"
                  data-name="Group 40726"
                  transform="translate(0)"
                >
                  <rect
                    id="Rectangle_19432"
                    data-name="Rectangle 19432"
                    width="132.439"
                    height="99.708"
                    transform="translate(0 132.346) rotate(-87.839)"
                    fill="#dbdbdb"
                  />
                </g>
              </g>
              <g
                id="Group_40728"
                data-name="Group 40728"
                transform="translate(65.99 7.454)"
              >
                <path
                  id="Path_63094"
                  data-name="Path 63094"
                  d="M307.534,73.564l-2.2-.083-.278,7.373a.75.75,0,0,1-.789.731.757.757,0,0,1-.73-.788l.278-7.373-2.181-.082a.77.77,0,0,1-.731-.8.75.75,0,0,1,.789-.731l5.9.223a.757.757,0,0,1,.73.788A.778.778,0,0,1,307.534,73.564Z"
                  transform="translate(-300.907 -71.808)"
                  fill="#fff"
                />
                <path
                  id="Path_63095"
                  data-name="Path 63095"
                  d="M328.5,81.76l.307-8.146a.75.75,0,0,1,.789-.731h.042l4.473.169a.766.766,0,0,1,.73.788.778.778,0,0,1-.788.745l-3.742-.141-.1,2.527,3.218.122a.767.767,0,0,1-.058,1.532l-3.218-.122-.1,2.541,3.742.141a.767.767,0,0,1-.058,1.532l-4.473-.169c-.028,0-.028-.015-.028-.015l-.014.014A.758.758,0,0,1,328.5,81.76Z"
                  transform="translate(-319.105 -72.517)"
                  fill="#fff"
                />
                <path
                  id="Path_63096"
                  data-name="Path 63096"
                  d="M351.526,80.661a.721.721,0,0,1,1.012-.059,4.5,4.5,0,0,0,2.6,1.162,2.978,2.978,0,0,0,1.745-.445,1.243,1.243,0,0,0,.632-.972.788.788,0,0,0-.108-.447,1.309,1.309,0,0,0-.4-.43,5.551,5.551,0,0,0-1.868-.72h-.028a7.474,7.474,0,0,1-1.761-.606,2.973,2.973,0,0,1-1.243-1.125,2.121,2.121,0,0,1-.274-1.144,2.553,2.553,0,0,1,1.18-1.974,4.084,4.084,0,0,1,2.417-.642,5.407,5.407,0,0,1,2.968,1.218.711.711,0,0,1,.156.987.7.7,0,0,1-.988.17,4.006,4.006,0,0,0-2.189-.967,2.644,2.644,0,0,0-1.565.411,1.1,1.1,0,0,0-.557.85.67.67,0,0,0,.082.39,1.322,1.322,0,0,0,.358.373,4.761,4.761,0,0,0,1.7.673h.028a8.14,8.14,0,0,1,1.884.652,3.235,3.235,0,0,1,1.337,1.2,2.243,2.243,0,0,1,.287,1.186,2.674,2.674,0,0,1-1.269,2.095,4.316,4.316,0,0,1-2.584.691,5.953,5.953,0,0,1-3.482-1.514A.736.736,0,0,1,351.526,80.661Z"
                  transform="translate(-334.185 -72.763)"
                  fill="#fff"
                />
                <path
                  id="Path_63097"
                  data-name="Path 63097"
                  d="M384.362,76.463l-2.2-.083-.278,7.373a.76.76,0,1,1-1.519-.057l.278-7.373-2.181-.082a.77.77,0,0,1-.731-.8.75.75,0,0,1,.789-.731l5.9.223a.758.758,0,0,1,.73.788A.778.778,0,0,1,384.362,76.463Z"
                  transform="translate(-351.585 -73.721)"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
          <g id="Floor" transform="translate(0 139.649)">
            <g
              id="Group_40730"
              data-name="Group 40730"
              transform="translate(0)"
            >
              <path
                id="Path_63098"
                data-name="Path 63098"
                d="M42.588,460.345c45.23-.208,95.967-.21,141.2,0-45.23.21-95.967.209-141.2,0Z"
                transform="translate(-42.588 -460.188)"
                fill="#263238"
              />
            </g>
          </g>
          <g id="Shadow" transform="translate(79.35 140.976)">
            <path
              id="Path_63099"
              data-name="Path 63099"
              d="M305.562,466.125c0,1.125-6.682,2.038-14.925,2.038s-14.926-.912-14.926-2.038,6.682-2.037,14.926-2.037S305.562,465,305.562,466.125Z"
              transform="translate(-275.711 -464.088)"
              fill="#ebebeb"
            />
          </g>
          <g id="Letter" transform="translate(14.627 0.795)">
            <g
              id="Group_40773"
              data-name="Group 40773"
              transform="translate(0 0)"
            >
              <g id="Group_40772" data-name="Group 40772">
                <g id="Group_40741" data-name="Group 40741">
                  <path
                    id="Path_63129"
                    data-name="Path 63129"
                    d="M197.633,172.927,99.678,183.874,85.966,61.169l77.8-8.7,22.295,16.9Z"
                    transform="translate(-85.828 -52.395)"
                    fill="#fff"
                  />
                  <path
                    id="Path_63130"
                    data-name="Path 63130"
                    d="M197.365,172.778c-.059.021-97.976,11.02-98.025,11.036S85.608,61.051,85.574,61.033l-.014-.124.124-.014c.069.019,77.82-8.72,77.868-8.649l22.314,16.93c.029.017,11.477,103.578,11.5,103.6Zm0,0c0,.019-11.71-103.758-11.625-103.493L163.437,52.4c.374-.022-77.817,8.77-77.725,8.744l.11-.138,13.669,122.71c-.547-.078,98-10.942,97.873-10.937Z"
                    transform="translate(-85.56 -52.246)"
                    fill="#263238"
                  />
                </g>
                <path
                  id="Path_63131"
                  data-name="Path 63131"
                  d="M314.527,52.48l22.3,16.895-20.157,2.253Z"
                  transform="translate(-236.592 -52.4)"
                  fill="#ebebeb"
                />
                <g
                  id="Group_40745"
                  data-name="Group 40745"
                  transform="translate(15.995 52.313)"
                >
                  <g
                    id="Group_40743"
                    data-name="Group 40743"
                    transform="translate(0 0)"
                  >
                    <g id="Group_40742" data-name="Group 40742">
                      <path
                        id="Path_63132"
                        data-name="Path 63132"
                        d="M145.853,213.223v-.008l-13.3,1.486,1.332,11.861h0l.566,5.074.162,1.443,64.9-7.28v0l13.3-1.486-.162-1.443-1.165-10.415h0l-.57-5.073-.159-1.447Zm64.111-1.288.077.683,1.166,10.419-7.487.837v-.008l-67.831,7.609-.489-4.387h0l-1.246-11.1,9.325-1.043v.008l65.993-7.4Z"
                        transform="translate(-132.551 -205.939)"
                        fill={primaryColor}
                      />
                    </g>
                  </g>
                  <g
                    id="Group_40744"
                    data-name="Group 40744"
                    transform="translate(5.785 5.278)"
                  >
                    <path
                      id="Path_63133"
                      data-name="Path 63133"
                      d="M154.974,248.918l-3.4.382-.481,1.9a.792.792,0,0,1-.674.572.81.81,0,0,1-.271-.012.8.8,0,0,1-.576-.956l2.169-8.6a.79.79,0,0,1,.688-.574.775.775,0,0,1,.8.407l4.022,7.9A.8.8,0,0,1,156.9,251a.752.752,0,0,1-.261.072.761.761,0,0,1-.77-.41Zm-.748-1.477-1.473-2.885-.8,3.139Z"
                      transform="translate(-149.548 -234.753)"
                      fill={primaryColor}
                    />
                    <path
                      id="Path_63134"
                      data-name="Path 63134"
                      d="M176.094,248.153l-.928-8.264a.765.765,0,0,1,.685-.857l1.653-.186a4.933,4.933,0,0,1,1.1,9.805l-1.653.185A.774.774,0,0,1,176.094,248.153Zm1.467-.959.869-.1a3.369,3.369,0,0,0-.752-6.7l-.869.1Z"
                      transform="translate(-166.443 -232.902)"
                      fill={primaryColor}
                    />
                    <path
                      id="Path_63135"
                      data-name="Path 63135"
                      d="M213.2,234.537l.928,8.264a.8.8,0,0,1-.7.858.773.773,0,0,1-.857-.683l-.662-5.9-1.7,3.028a.768.768,0,0,1-.595.394l-.014,0-.014,0a.794.794,0,0,1-.681-.251l-2.318-2.576.662,5.9a.782.782,0,0,1-1.555.175l-.928-8.264a.782.782,0,0,1,.684-.857l.042,0a.761.761,0,0,1,.652.254l3.221,3.552,2.353-4.178a.766.766,0,0,1,.595-.393l.014,0A.8.8,0,0,1,213.2,234.537Z"
                      transform="translate(-185.972 -229.629)"
                      fill={primaryColor}
                    />
                    <path
                      id="Path_63136"
                      data-name="Path 63136"
                      d="M239.809,233.04a.765.765,0,0,1,.684-.858.785.785,0,0,1,.87.683l.928,8.264a.785.785,0,0,1-.7.858.765.765,0,0,1-.857-.683Z"
                      transform="translate(-209.083 -228.524)"
                      fill={primaryColor}
                    />
                    <path
                      id="Path_63137"
                      data-name="Path 63137"
                      d="M256.7,230.635l-2.227.25.84,7.481a.764.764,0,0,1-.684.856.773.773,0,0,1-.856-.684l-.84-7.481-2.213.248a.785.785,0,0,1-.859-.7.765.765,0,0,1,.684-.858l5.981-.672a.773.773,0,0,1,.856.685A.793.793,0,0,1,256.7,230.635Z"
                      transform="translate(-215.711 -226.478)"
                      fill={primaryColor}
                    />
                    <path
                      id="Path_63138"
                      data-name="Path 63138"
                      d="M283.377,227.639l-2.227.25.84,7.481a.764.764,0,0,1-.684.856.773.773,0,0,1-.856-.684l-.84-7.481-2.213.248a.785.785,0,0,1-.859-.7.765.765,0,0,1,.684-.858l5.981-.672a.773.773,0,0,1,.856.684A.794.794,0,0,1,283.377,227.639Z"
                      transform="translate(-233.309 -224.502)"
                      fill={primaryColor}
                    />
                    <path
                      id="Path_63139"
                      data-name="Path 63139"
                      d="M306.368,232.939l-.928-8.264a.765.765,0,0,1,.684-.857l.014,0,.029,0,4.538-.51a.782.782,0,0,1,.856.685.794.794,0,0,1-.682.87l-3.8.426.288,2.564,3.264-.367a.782.782,0,0,1,.175,1.554l-3.264.367.289,2.578,3.8-.427a.782.782,0,0,1,.175,1.555l-4.538.51c-.029,0-.03-.011-.03-.011l-.012.015A.774.774,0,0,1,306.368,232.939Z"
                      transform="translate(-252.374 -222.667)"
                      fill={primaryColor}
                    />
                    <path
                      id="Path_63140"
                      data-name="Path 63140"
                      d="M330.785,230.783l-.928-8.264a.765.765,0,0,1,.684-.857l1.653-.185a4.933,4.933,0,0,1,1.1,9.805l-1.653.185A.774.774,0,0,1,330.785,230.783Zm1.467-.959.869-.1a3.369,3.369,0,0,0-.752-6.7l-.869.1Z"
                      transform="translate(-268.48 -221.445)"
                      fill={primaryColor}
                    />
                  </g>
                </g>
                <g
                  id="Group_40764"
                  data-name="Group 40764"
                  transform="translate(14.179 36.269)"
                >
                  <g
                    id="Group_40746"
                    data-name="Group 40746"
                    transform="translate(0 0)"
                  >
                    <rect
                      id="Rectangle_19438"
                      data-name="Rectangle 19438"
                      width="78.71"
                      height="1.339"
                      transform="translate(78.371 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40747"
                    data-name="Group 40747"
                    transform="translate(0.979 15.053)"
                  >
                    <rect
                      id="Rectangle_19439"
                      data-name="Rectangle 19439"
                      width="22.155"
                      height="1.339"
                      transform="translate(22.167 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40748"
                    data-name="Group 40748"
                    transform="translate(45.094 5.435)"
                  >
                    <rect
                      id="Rectangle_19440"
                      data-name="Rectangle 19440"
                      width="24.398"
                      height="1.339"
                      transform="translate(24.395 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40749"
                    data-name="Group 40749"
                    transform="translate(20.524 8.608)"
                  >
                    <rect
                      id="Rectangle_19441"
                      data-name="Rectangle 19441"
                      width="20.547"
                      height="1.339"
                      transform="translate(20.569 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40750"
                    data-name="Group 40750"
                    transform="translate(26.839 13.482)"
                  >
                    <rect
                      id="Rectangle_19442"
                      data-name="Rectangle 19442"
                      width="10.29"
                      height="1.339"
                      transform="translate(10.375 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40751"
                    data-name="Group 40751"
                    transform="translate(0.489 11.293)"
                  >
                    <rect
                      id="Rectangle_19443"
                      data-name="Rectangle 19443"
                      width="16.521"
                      height="1.339"
                      transform="translate(16.567 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40752"
                    data-name="Group 40752"
                    transform="translate(4.488 47.506)"
                  >
                    <rect
                      id="Rectangle_19444"
                      data-name="Rectangle 19444"
                      width="12.748"
                      height="1.339"
                      transform="translate(12.817 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40753"
                    data-name="Group 40753"
                    transform="translate(20.106 44.691)"
                  >
                    <rect
                      id="Rectangle_19445"
                      data-name="Rectangle 19445"
                      width="22.387"
                      height="1.339"
                      transform="translate(22.396 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40754"
                    data-name="Group 40754"
                    transform="translate(45.449 42.916)"
                  >
                    <rect
                      id="Rectangle_19446"
                      data-name="Rectangle 19446"
                      width="12.877"
                      height="1.339"
                      transform="translate(12.946 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40755"
                    data-name="Group 40755"
                    transform="translate(61.668 40.846)"
                  >
                    <rect
                      id="Rectangle_19447"
                      data-name="Rectangle 19447"
                      width="15.202"
                      height="1.339"
                      transform="translate(15.256 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40756"
                    data-name="Group 40756"
                    transform="translate(4.978 51.082)"
                  >
                    <rect
                      id="Rectangle_19448"
                      data-name="Rectangle 19448"
                      width="20.037"
                      height="1.339"
                      transform="translate(20.061 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40757"
                    data-name="Group 40757"
                    transform="translate(28.138 48.112)"
                  >
                    <rect
                      id="Rectangle_19449"
                      data-name="Rectangle 19449"
                      width="23.485"
                      height="1.339"
                      transform="translate(23.488 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40758"
                    data-name="Group 40758"
                    transform="translate(54.821 46.061)"
                  >
                    <rect
                      id="Rectangle_19450"
                      data-name="Rectangle 19450"
                      width="15.111"
                      height="1.339"
                      transform="translate(15.166 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40759"
                    data-name="Group 40759"
                    transform="translate(5.958 60.371)"
                  >
                    <rect
                      id="Rectangle_19451"
                      data-name="Rectangle 19451"
                      width="15.38"
                      height="1.339"
                      transform="translate(15.434 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40760"
                    data-name="Group 40760"
                    transform="translate(46.389 71.194)"
                  >
                    <rect
                      id="Rectangle_19452"
                      data-name="Rectangle 19452"
                      width="40.045"
                      height="1.339"
                      transform="translate(39.946 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40761"
                    data-name="Group 40761"
                    transform="translate(24.535 57.762)"
                  >
                    <rect
                      id="Rectangle_19453"
                      data-name="Rectangle 19453"
                      width="20.188"
                      height="1.339"
                      transform="translate(20.212 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40762"
                    data-name="Group 40762"
                    transform="translate(47.835 56.28)"
                  >
                    <rect
                      id="Rectangle_19454"
                      data-name="Rectangle 19454"
                      width="10.094"
                      height="1.339"
                      transform="translate(10.18 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40763"
                    data-name="Group 40763"
                    transform="translate(41.412 11.162)"
                  >
                    <rect
                      id="Rectangle_19455"
                      data-name="Rectangle 19455"
                      width="16.521"
                      height="1.339"
                      transform="translate(16.567 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                </g>
                <g
                  id="Group_40769"
                  data-name="Group 40769"
                  transform="translate(10.97 13.987)"
                >
                  <g
                    id="Group_40765"
                    data-name="Group 40765"
                    transform="translate(0 0)"
                  >
                    <rect
                      id="Rectangle_19456"
                      data-name="Rectangle 19456"
                      width="21.167"
                      height="1.339"
                      transform="translate(21.184 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40766"
                    data-name="Group 40766"
                    transform="translate(0.98 8.771)"
                  >
                    <rect
                      id="Rectangle_19457"
                      data-name="Rectangle 19457"
                      width="21.167"
                      height="1.339"
                      transform="translate(21.184 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40767"
                    data-name="Group 40767"
                    transform="translate(0.49 4.984)"
                  >
                    <rect
                      id="Rectangle_19458"
                      data-name="Rectangle 19458"
                      width="15.784"
                      height="1.339"
                      transform="translate(15.835 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                  <g
                    id="Group_40768"
                    data-name="Group 40768"
                    transform="translate(1.47 14.333)"
                  >
                    <rect
                      id="Rectangle_19459"
                      data-name="Rectangle 19459"
                      width="10.583"
                      height="1.339"
                      transform="translate(10.666 1.33) rotate(173.621)"
                      fill="#dbdbdb"
                    />
                  </g>
                </g>
                <path
                  id="Path_63141"
                  data-name="Path 63141"
                  d="M266.733,354.992q1.3-1.13,2.694-2.153a13.8,13.8,0,0,1,2.977-1.765,3.318,3.318,0,0,1,.424-.13.455.455,0,0,1,.495.1,1.641,1.641,0,0,1,.3.866,10.155,10.155,0,0,1,.016,1.741c-.072,1.154-.228,2.3-.413,3.433a51.523,51.523,0,0,1-1.549,6.734,10.406,10.406,0,0,1-.64,1.631,1.98,1.98,0,0,1-.268.393.483.483,0,0,1-.283.166.316.316,0,0,1-.215-.051l-.114-.093a1.717,1.717,0,0,1-.345-.887,11.636,11.636,0,0,1,.22-3.479,20.064,20.064,0,0,1,.93-3.339,9.772,9.772,0,0,1,1.7-3.031,3.191,3.191,0,0,1,1.5-.93,1.862,1.862,0,0,1,.9-.025,1.4,1.4,0,0,1,.7.575,4.268,4.268,0,0,0,.553.632.7.7,0,0,0,.717.152,4.588,4.588,0,0,0,1.341-1c.208-.2.413-.4.631-.59a3.055,3.055,0,0,1,.349-.27.436.436,0,0,1,.471-.077c.255.255.232.56.372.8a.509.509,0,0,0,.627.306,5.136,5.136,0,0,0,1.134-1.237c.341-.46.668-.932.993-1.4.649-.946,1.286-1.9,1.954-2.84.335-.468.676-.933,1.045-1.379a6.891,6.891,0,0,1,.594-.642,2.023,2.023,0,0,1,.362-.275.625.625,0,0,1,.245-.085.336.336,0,0,1,.28.112,1.527,1.527,0,0,1,.219.9,7.511,7.511,0,0,1-.041.874,16.766,16.766,0,0,1-.271,1.714,16.968,16.968,0,0,1-1.008,3.322,3.441,3.441,0,0,1-.46.777.629.629,0,0,1-.481.259,1.522,1.522,0,0,1-.473-.078,2.134,2.134,0,0,1-1.307-1.269.788.788,0,0,1,.006-.544.546.546,0,0,1,.2-.237.58.58,0,0,1,.287-.1,3.286,3.286,0,0,1,.909.111c.571.132,1.12.3,1.671.474s1.1.344,1.644.5c.274.075.549.147.82.194a2.15,2.15,0,0,0,.389.039.568.568,0,0,0,.305-.1c.4-.264.634-.829,1.015-1.3a1.4,1.4,0,0,1,.824-.544.449.449,0,0,1,.364.075.469.469,0,0,1,.158.336,2.3,2.3,0,0,1-.032.475c-.05.267-.046.594.028.6.089.065.415-.021.649-.11a4.384,4.384,0,0,0,1.356-.915,8.555,8.555,0,0,1,.673-.572,1.443,1.443,0,0,1,.928-.334,3.559,3.559,0,0,1,1.582.9,4,4,0,0,0,.668.46c.109.051.207.063.227.036a2.225,2.225,0,0,0,.305-.238,13.537,13.537,0,0,0,1.167-1.228,14.819,14.819,0,0,0,1.921-2.791,2.876,2.876,0,0,0,.387-1.539c-.056-.512-.61-.687-1.167-.711a9.36,9.36,0,0,0-3.342.423,8.288,8.288,0,0,0-1.565.64,3.418,3.418,0,0,0-.678.473c-.193.179-.356.421-.272.617a1.009,1.009,0,0,0,.6.436c.257.095.542.153.816.226a15.587,15.587,0,0,0,1.684.3,37.911,37.911,0,0,0,6.865-.114l0,.039a36.117,36.117,0,0,1-6.89.269,15.827,15.827,0,0,1-1.711-.278c-.281-.071-.562-.124-.846-.224a1.207,1.207,0,0,1-.746-.563.853.853,0,0,1,.322-.89,3.68,3.68,0,0,1,.724-.521,8.534,8.534,0,0,1,1.609-.684,9.653,9.653,0,0,1,3.452-.481,2.441,2.441,0,0,1,.9.194,1.061,1.061,0,0,1,.591.788,3.18,3.18,0,0,1-.4,1.765,14.217,14.217,0,0,1-1.957,2.886,13.923,13.923,0,0,1-1.2,1.271,2.514,2.514,0,0,1-.374.289.642.642,0,0,1-.6-.019,4.256,4.256,0,0,1-.752-.509,3.367,3.367,0,0,0-1.363-.807c-.427-.015-.873.433-1.288.8a4.789,4.789,0,0,1-1.484,1,1.281,1.281,0,0,1-1.015.076.623.623,0,0,1-.262-.552,3.016,3.016,0,0,1,.041-.461,2.054,2.054,0,0,0,.033-.383c0-.051-.021-.069,0-.05s0,0-.048.008a1.015,1.015,0,0,0-.573.4c-.35.4-.552.987-1.119,1.377a.958.958,0,0,1-.5.157,2.454,2.454,0,0,1-.466-.047c-.295-.053-.575-.129-.855-.208-.558-.159-1.1-.337-1.652-.509s-1.093-.346-1.641-.476a3.046,3.046,0,0,0-.794-.108c-.186,0-.268.181-.191.42a1.817,1.817,0,0,0,1.078,1.061,1.2,1.2,0,0,0,.372.067c.077.013.152-.051.243-.147a3.169,3.169,0,0,0,.421-.7,16.7,16.7,0,0,0,1.03-3.248,16.507,16.507,0,0,0,.288-1.684,7.323,7.323,0,0,0,.05-.845,1.413,1.413,0,0,0-.151-.755c-.1-.141-.4.086-.586.256a6.776,6.776,0,0,0-.581.617c-.367.436-.711.895-1.048,1.358-.674.928-1.318,1.879-1.977,2.82-.329.471-.661.94-1.008,1.4a5.053,5.053,0,0,1-1.2,1.268.64.64,0,0,1-.785-.366c-.139-.256-.168-.595-.337-.748-.078-.058-.212.008-.323.083a2.9,2.9,0,0,0-.328.261c-.211.19-.414.394-.62.594a4.678,4.678,0,0,1-1.392,1.056.879.879,0,0,1-.887-.174,4.379,4.379,0,0,1-.588-.654c-.179-.216-.358-.452-.6-.5a1.667,1.667,0,0,0-.8.034,2.973,2.973,0,0,0-1.38.883,9.6,9.6,0,0,0-1.616,2.968,19.815,19.815,0,0,0-.883,3.3,11.4,11.4,0,0,0-.184,3.373,1.457,1.457,0,0,0,.261.7l.053.042c.015.007-.013,0-.013,0a.26.26,0,0,0,.072-.061,1.671,1.671,0,0,0,.21-.321,11.566,11.566,0,0,0,.625-1.57,51.243,51.243,0,0,0,1.607-6.673c.195-1.128.362-2.263.445-3.4a9.985,9.985,0,0,0,0-1.7,1.5,1.5,0,0,0-.234-.747.245.245,0,0,0-.3-.048,3.117,3.117,0,0,0-.4.119,15.054,15.054,0,0,0-2.97,1.682c-.942.653-1.858,1.348-2.744,2.077Z"
                  transform="translate(-205.066 -246.035)"
                  fill="#dbdbdb"
                />
                <g
                  id="Group_40771"
                  data-name="Group 40771"
                  transform="translate(78.84 97.949)"
                >
                  <g id="Group_40770" data-name="Group 40770">
                    <path
                      id="Path_63142"
                      data-name="Path 63142"
                      d="M332.241,347.2a.428.428,0,0,1-.084-.754.424.424,0,0,0-.17-.773.429.429,0,0,1-.353-.377.415.415,0,0,1,.114-.341.428.428,0,0,0,.119-.342.421.421,0,0,0-.446-.381.427.427,0,0,1-.445-.381.406.406,0,0,1,.062-.271.429.429,0,0,0-.407-.653.316.316,0,0,0-.064.012.431.431,0,0,1-.536-.366.407.407,0,0,1,.025-.193.428.428,0,0,0-.444-.57.442.442,0,0,0-.148.044.431.431,0,0,1-.621-.333.414.414,0,0,1,0-.107.426.426,0,0,0-.467-.485.432.432,0,0,0-.221.094.428.428,0,0,1-.69-.288l0-.018a.428.428,0,0,0-.479-.391.418.418,0,0,0-.279.152.428.428,0,0,1-.284.152.422.422,0,0,1-.456-.305.431.431,0,0,0-.465-.3.42.42,0,0,0-.326.226.427.427,0,0,1-.759.006.427.427,0,0,0-.787.089.422.422,0,0,1-.368.315.427.427,0,0,1-.374-.152.413.413,0,0,0-.369-.148.423.423,0,0,0-.381.4.431.431,0,0,1-.692.314.425.425,0,0,0-.684.378l0,.023a.433.433,0,0,1-.38.492.422.422,0,0,1-.231-.039.426.426,0,0,0-.61.425.473.473,0,0,0,.026.108.43.43,0,0,1-.352.577.441.441,0,0,1-.149-.011.43.43,0,0,0-.531.462.422.422,0,0,0,.067.182.428.428,0,0,1-.311.655.327.327,0,0,1-.065,0,.428.428,0,0,0-.316.73.408.408,0,0,1,.121.251.427.427,0,0,1-.35.47.423.423,0,0,0-.345.469.416.416,0,0,0,.187.308.415.415,0,0,1,.187.308.428.428,0,0,1-.26.446.424.424,0,0,0,.005.791.428.428,0,0,1,.085.755.42.42,0,0,0-.187.4.426.426,0,0,0,.357.372.429.429,0,0,1,.353.377.416.416,0,0,1-.114.342.415.415,0,0,0-.114.342.426.426,0,0,0,.441.381.426.426,0,0,1,.383.651.429.429,0,0,0,.407.653.294.294,0,0,0,.064-.012.431.431,0,0,1,.536.366.412.412,0,0,1-.025.193.428.428,0,0,0,.448.57.449.449,0,0,0,.148-.044.427.427,0,0,1,.616.334.451.451,0,0,1,0,.107.426.426,0,0,0,.467.485.435.435,0,0,0,.221-.094.429.429,0,0,1,.694.288l0,.014a.423.423,0,0,0,.475.4.417.417,0,0,0,.279-.152.433.433,0,0,1,.283-.157.427.427,0,0,1,.46.3.425.425,0,0,0,.787.079.431.431,0,0,1,.759-.006.427.427,0,0,0,.787-.088.424.424,0,0,1,.368-.31.42.42,0,0,1,.373.148.429.429,0,0,0,.754-.251.422.422,0,0,1,.376-.4.432.432,0,0,1,.311.09.43.43,0,0,0,.688-.387l0-.018a.428.428,0,0,1,.607-.448.426.426,0,0,0,.61-.425.463.463,0,0,0-.026-.108.43.43,0,0,1,.352-.577.437.437,0,0,1,.154.01.428.428,0,0,0,.527-.462.424.424,0,0,0-.067-.182.428.428,0,0,1,.311-.655.32.32,0,0,1,.065,0,.429.429,0,0,0,.316-.73.427.427,0,0,1,.229-.721.426.426,0,0,0,.35-.47.419.419,0,0,0-.192-.307.415.415,0,0,1-.187-.308.429.429,0,0,1,.26-.446.427.427,0,0,0,.265-.446A.416.416,0,0,0,332.241,347.2Zm-6.651,7.03a6.623,6.623,0,1,1,5.845-7.324A6.624,6.624,0,0,1,325.59,354.226Z"
                      transform="translate(-317.187 -340.014)"
                      fill={primaryColor}
                    />
                    <path
                      id="Path_63143"
                      data-name="Path 63143"
                      d="M328.379,356.573a6.2,6.2,0,1,1,5.469-6.854A6.207,6.207,0,0,1,328.379,356.573Zm-1.358-12.095a5.97,5.97,0,1,0,6.6,5.267A5.977,5.977,0,0,0,327.021,344.479Z"
                      transform="translate(-320.023 -342.783)"
                      fill={primaryColor}
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="Speech_Bubble" transform="translate(107.481 16.333)">
            <g
              id="Group_40830"
              data-name="Group 40830"
              transform="translate(0 0)"
            >
              <g id="Group_40829" data-name="Group 40829">
                <g id="Group_40828" data-name="Group 40828">
                  <path
                    id="Path_63211"
                    data-name="Path 63211"
                    d="M374.539,105.489a7.386,7.386,0,0,1-11.791,5.932l-3.62.924,1.507-3.371a7.389,7.389,0,1,1,13.9-3.485Z"
                    transform="translate(-358.866 -98.03)"
                    fill="#fff"
                  />
                  <path
                    id="Path_63212"
                    data-name="Path 63212"
                    d="M374.031,105.354a7.464,7.464,0,0,1-11.864,6.029l.1.02-3.613.951-.3.079.126-.285,1.494-3.377.006.145a7.472,7.472,0,1,1,14.048-3.563Zm0,0a7.3,7.3,0,1,0-13.76,3.408l.038.072-.033.072-1.52,3.365-.173-.206,3.627-.9.057-.014.045.034a7.328,7.328,0,0,0,11.718-5.834Z"
                    transform="translate(-358.358 -97.894)"
                    fill="#263238"
                  />
                </g>
              </g>
              <path
                id="Path_63213"
                data-name="Path 63213"
                d="M373.248,115.686l-3.311-3.352,1.112-1.1,1.934,1.958,4.019-6.3,1.319.841Z"
                transform="translate(-365.996 -103.829)"
                fill={primaryColor}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
